//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { DateTime, Duration } from "luxon";

export interface IAppControllerClient {

    /**
     * @return Shows if the App is running.
     */
    rootTest(): Promise<string>;

    /**
     * @return Gives information about the environment of te API
     */
    getEnvironment(): Promise<EnvironmentDto>;

    /**
     * @return Shows if the App is secured.
     */
    securedTest(): Promise<string>;

    loggedInTest(): Promise<string>;

    adminTest(): Promise<string>;
}

export class AppControllerClient implements IAppControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Shows if the App is running.
     */
    rootTest(): Promise<string> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRootTest(_response);
        });
    }

    protected processRootTest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Gives information about the environment of te API
     */
    getEnvironment(): Promise<EnvironmentDto> {
        let url_ = this.baseUrl + "/environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEnvironment(_response);
        });
    }

    protected processGetEnvironment(response: Response): Promise<EnvironmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentDto>(null as any);
    }

    /**
     * @return Shows if the App is secured.
     */
    securedTest(): Promise<string> {
        let url_ = this.baseUrl + "/secured";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSecuredTest(_response);
        });
    }

    protected processSecuredTest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    loggedInTest(): Promise<string> {
        let url_ = this.baseUrl + "/loggedIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoggedInTest(_response);
        });
    }

    protected processLoggedInTest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    adminTest(): Promise<string> {
        let url_ = this.baseUrl + "/adminOnly";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminTest(_response);
        });
    }

    protected processAdminTest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IAuthControllerClient {

    /**
     * @return Returns a token.
     */
    login(body: CredentialsDto): Promise<TokenDto>;

    /**
     * @return Returns the user name.
     */
    getProfile(): Promise<UserInfoDto>;

    /**
     * @return Initializes a password change request.
     */
    changePasswordRequest(body: ChangePasswordRequestDto): Promise<ResponseDto>;

    /**
     * @return Changes the Password.
     */
    changePassword(body: ChangePasswordDto): Promise<ResponseDto>;
}

export class AuthControllerClient implements IAuthControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Returns a token.
     */
    login(body: CredentialsDto): Promise<TokenDto> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<TokenDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TokenDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenDto>(null as any);
    }

    /**
     * @return Returns the user name.
     */
    getProfile(): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/auth/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }

    /**
     * @return Initializes a password change request.
     */
    changePasswordRequest(body: ChangePasswordRequestDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/auth/changePasswordRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePasswordRequest(_response);
        });
    }

    protected processChangePasswordRequest(response: Response): Promise<ResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ResponseDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    /**
     * @return Changes the Password.
     */
    changePassword(body: ChangePasswordDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/auth/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<ResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ResponseDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export interface IReservationControllerClient {

    /**
     * @return Returns all concert series.
     */
    getConcertSeries(): Promise<ConcertSeriesDto[]>;

    /**
     * @return Returns concert series with ticket sales.
     */
    getConcertSeriesWithTicketSale(): Promise<ConcertSeriesDto[]>;

    /**
     * @return Returns concert series to show on the entry page.
     */
    getConcertSeriesForWelcomePage(): Promise<ConcertSeriesDto[]>;

    /**
     * @return Returns concert series to show on the entry page.
     */
    getConcertSeriesForArchive(year: number): Promise<ConcertSeriesDto[]>;

    /**
     * @return Returns information about a concert.
     */
    getConcertInfos(id: number): Promise<ReservationInfoDto>;

    /**
     * @return Returns concerts of a series.
     */
    getConcerts(id: number): Promise<ConcertDto[]>;

    /**
     * @return Returns whether there are past concert series for the given year.
     */
    hasPastConcertSeries(year: number): Promise<boolean>;

    /**
     * @return Returns a plan.
     */
    getPlan(id: number): Promise<PlanDto>;

    /**
     * @return Returns reserved seats of a concert
     */
    getReservations(id: number): Promise<SeatReservationDto[]>;

    /**
     * @return Returns the Data of one Order
     */
    getOrder(concertId: number, guid: string, verifyEmail: boolean): Promise<OrderDto>;

    /**
     * @return Returns the ticket info of an order
     */
    getTicketInfo(concertId: number, guid: string): Promise<TicketInfoDto>;

    getQrCode(concertId: number, guid: string): Promise<void>;

    /**
     * @param earlyAccess (optional) The early access guid.
     * @return Check if ticket sale is possible.
     */
    checkTicketSale(concertId: number, earlyAccess?: string | undefined): Promise<TicketSaleCheckResponseDto>;

    /**
     * @return Saves an order
     */
    reserve(body: OrderInfoDto): Promise<ResponseDto>;
}

export class ReservationControllerClient implements IReservationControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Returns all concert series.
     */
    getConcertSeries(): Promise<ConcertSeriesDto[]> {
        let url_ = this.baseUrl + "/tickets/concertSeries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertSeries(_response);
        });
    }

    protected processGetConcertSeries(response: Response): Promise<ConcertSeriesDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesDto[]>(null as any);
    }

    /**
     * @return Returns concert series with ticket sales.
     */
    getConcertSeriesWithTicketSale(): Promise<ConcertSeriesDto[]> {
        let url_ = this.baseUrl + "/tickets/concertSeriesTicketSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertSeriesWithTicketSale(_response);
        });
    }

    protected processGetConcertSeriesWithTicketSale(response: Response): Promise<ConcertSeriesDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesDto[]>(null as any);
    }

    /**
     * @return Returns concert series to show on the entry page.
     */
    getConcertSeriesForWelcomePage(): Promise<ConcertSeriesDto[]> {
        let url_ = this.baseUrl + "/tickets/concertSeriesEntry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertSeriesForWelcomePage(_response);
        });
    }

    protected processGetConcertSeriesForWelcomePage(response: Response): Promise<ConcertSeriesDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesDto[]>(null as any);
    }

    /**
     * @return Returns concert series to show on the entry page.
     */
    getConcertSeriesForArchive(year: number): Promise<ConcertSeriesDto[]> {
        let url_ = this.baseUrl + "/tickets/concertSeriesArchive/{year}";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertSeriesForArchive(_response);
        });
    }

    protected processGetConcertSeriesForArchive(response: Response): Promise<ConcertSeriesDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesDto[]>(null as any);
    }

    /**
     * @return Returns information about a concert.
     */
    getConcertInfos(id: number): Promise<ReservationInfoDto> {
        let url_ = this.baseUrl + "/tickets/reservationInfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertInfos(_response);
        });
    }

    protected processGetConcertInfos(response: Response): Promise<ReservationInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationInfoDto>(null as any);
    }

    /**
     * @return Returns concerts of a series.
     */
    getConcerts(id: number): Promise<ConcertDto[]> {
        let url_ = this.baseUrl + "/tickets/concerts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcerts(_response);
        });
    }

    protected processGetConcerts(response: Response): Promise<ConcertDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertDto[]>(null as any);
    }

    /**
     * @return Returns whether there are past concert series for the given year.
     */
    hasPastConcertSeries(year: number): Promise<boolean> {
        let url_ = this.baseUrl + "/tickets/hasPastConcertSeries/{year}";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasPastConcertSeries(_response);
        });
    }

    protected processHasPastConcertSeries(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Returns a plan.
     */
    getPlan(id: number): Promise<PlanDto> {
        let url_ = this.baseUrl + "/tickets/plan/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlan(_response);
        });
    }

    protected processGetPlan(response: Response): Promise<PlanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanDto>(null as any);
    }

    /**
     * @return Returns reserved seats of a concert
     */
    getReservations(id: number): Promise<SeatReservationDto[]> {
        let url_ = this.baseUrl + "/tickets/reservations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReservations(_response);
        });
    }

    protected processGetReservations(response: Response): Promise<SeatReservationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeatReservationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeatReservationDto[]>(null as any);
    }

    /**
     * @return Returns the Data of one Order
     */
    getOrder(concertId: number, guid: string, verifyEmail: boolean): Promise<OrderDto> {
        let url_ = this.baseUrl + "/tickets/order/{concertId}/{guid}";
        if (concertId === undefined || concertId === null)
            throw new globalThis.Error("The parameter 'concertId' must be defined.");
        url_ = url_.replace("{concertId}", encodeURIComponent("" + concertId));
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        if (verifyEmail === undefined || verifyEmail === null)
            throw new globalThis.Error("The parameter 'verifyEmail' must be defined.");
        url_ = url_.replace("{verifyEmail}", encodeURIComponent("" + verifyEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrder(_response);
        });
    }

    protected processGetOrder(response: Response): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDto>(null as any);
    }

    /**
     * @return Returns the ticket info of an order
     */
    getTicketInfo(concertId: number, guid: string): Promise<TicketInfoDto> {
        let url_ = this.baseUrl + "/tickets/ticket/{concertId}/{guid}";
        if (concertId === undefined || concertId === null)
            throw new globalThis.Error("The parameter 'concertId' must be defined.");
        url_ = url_.replace("{concertId}", encodeURIComponent("" + concertId));
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTicketInfo(_response);
        });
    }

    protected processGetTicketInfo(response: Response): Promise<TicketInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketInfoDto>(null as any);
    }

    getQrCode(concertId: number, guid: string): Promise<void> {
        let url_ = this.baseUrl + "/tickets/qrcode/{concertId}/{guid}";
        if (concertId === undefined || concertId === null)
            throw new globalThis.Error("The parameter 'concertId' must be defined.");
        url_ = url_.replace("{concertId}", encodeURIComponent("" + concertId));
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQrCode(_response);
        });
    }

    protected processGetQrCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param earlyAccess (optional) The early access guid.
     * @return Check if ticket sale is possible.
     */
    checkTicketSale(concertId: number, earlyAccess?: string | undefined): Promise<TicketSaleCheckResponseDto> {
        let url_ = this.baseUrl + "/tickets/checkTicketSale/{concertId}?";
        if (concertId === undefined || concertId === null)
            throw new globalThis.Error("The parameter 'concertId' must be defined.");
        url_ = url_.replace("{concertId}", encodeURIComponent("" + concertId));
        if (earlyAccess === null)
            throw new globalThis.Error("The parameter 'earlyAccess' cannot be null.");
        else if (earlyAccess !== undefined)
            url_ += "earlyAccess=" + encodeURIComponent("" + earlyAccess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckTicketSale(_response);
        });
    }

    protected processCheckTicketSale(response: Response): Promise<TicketSaleCheckResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TicketSaleCheckResponseDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSaleCheckResponseDto>(null as any);
    }

    /**
     * @return Saves an order
     */
    reserve(body: OrderInfoDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/tickets/reserve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReserve(_response);
        });
    }

    protected processReserve(response: Response): Promise<ResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ResponseDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export interface IDownloadControllerClient {

    /**
     * @return Returns a csv with order infos.
     */
    getAllOrdersCSV(orderBy: OrderBy, desc: boolean): Promise<string>;

    /**
     * @return Returns a csv with order infos for one concert.
     */
    getOrdersForConcertCSV(id: number, orderBy: OrderBy2, desc: boolean): Promise<string>;

    /**
     * @return Returns a csv with reservation infos.
     */
    getAllReservationsCSV(byName: boolean, desc: boolean): Promise<string>;

    /**
     * @return Returns a csv with reservation infos for one concert.
     */
    getReservationsForConcertCSV(id: number, byName: boolean, desc: boolean): Promise<string>;

    /**
     * @return Returns a an xml with order infos.
     */
    getExcelExportForSeries(id: number): Promise<void>;
}

export class DownloadControllerClient implements IDownloadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Returns a csv with order infos.
     */
    getAllOrdersCSV(orderBy: OrderBy, desc: boolean): Promise<string> {
        let url_ = this.baseUrl + "/tickets/download/orders/all?";
        if (orderBy === undefined || orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' must be defined and cannot be null.");
        else
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (desc === undefined || desc === null)
            throw new globalThis.Error("The parameter 'desc' must be defined and cannot be null.");
        else
            url_ += "desc=" + encodeURIComponent("" + desc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrdersCSV(_response);
        });
    }

    protected processGetAllOrdersCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Returns a csv with order infos for one concert.
     */
    getOrdersForConcertCSV(id: number, orderBy: OrderBy2, desc: boolean): Promise<string> {
        let url_ = this.baseUrl + "/tickets/download/orders/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderBy === undefined || orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' must be defined and cannot be null.");
        else
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (desc === undefined || desc === null)
            throw new globalThis.Error("The parameter 'desc' must be defined and cannot be null.");
        else
            url_ += "desc=" + encodeURIComponent("" + desc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrdersForConcertCSV(_response);
        });
    }

    protected processGetOrdersForConcertCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Returns a csv with reservation infos.
     */
    getAllReservationsCSV(byName: boolean, desc: boolean): Promise<string> {
        let url_ = this.baseUrl + "/tickets/download/reservations/all?";
        if (byName === undefined || byName === null)
            throw new globalThis.Error("The parameter 'byName' must be defined and cannot be null.");
        else
            url_ += "byName=" + encodeURIComponent("" + byName) + "&";
        if (desc === undefined || desc === null)
            throw new globalThis.Error("The parameter 'desc' must be defined and cannot be null.");
        else
            url_ += "desc=" + encodeURIComponent("" + desc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllReservationsCSV(_response);
        });
    }

    protected processGetAllReservationsCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Returns a csv with reservation infos for one concert.
     */
    getReservationsForConcertCSV(id: number, byName: boolean, desc: boolean): Promise<string> {
        let url_ = this.baseUrl + "/tickets/download/reservations/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (byName === undefined || byName === null)
            throw new globalThis.Error("The parameter 'byName' must be defined and cannot be null.");
        else
            url_ += "byName=" + encodeURIComponent("" + byName) + "&";
        if (desc === undefined || desc === null)
            throw new globalThis.Error("The parameter 'desc' must be defined and cannot be null.");
        else
            url_ += "desc=" + encodeURIComponent("" + desc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReservationsForConcertCSV(_response);
        });
    }

    protected processGetReservationsForConcertCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Returns a an xml with order infos.
     */
    getExcelExportForSeries(id: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/download/excelexport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExcelExportForSeries(_response);
        });
    }

    protected processGetExcelExportForSeries(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAdminControllerClient {

    /**
     * @return Returns all orders.
     */
    getAllOrders(): Promise<OrderDataDto[]>;

    /**
     * @return Searches orders.
     */
    search(concertSeriesId: number, concertId: number, body: string): Promise<OrderDataDto[]>;

    /**
     * @return Set an order to payed or not payed.
     */
    setPayed(orderId: number, payed: boolean): Promise<void>;

    /**
     * @return Set an order to canceled or not canceled.
     */
    setCanceled(orderId: number, canceled: boolean): Promise<void>;

    /**
     * @return Set an order to payed or not payed.
     */
    deleteOrder(orderId: number): Promise<void>;

    /**
     * @return Searches orders.
     */
    updateTracingData(orderId: number, body: ContactTracingDataDto): Promise<void>;

    /**
     * @return Searches orders.
     */
    cancelOrder(orderId: number): Promise<void>;

    /**
     * @return Searches orders.
     */
    reactivateOrder(orderId: number): Promise<void>;

    /**
     * @return Searches orders.
     */
    cancelReservation(reservationId: number): Promise<void>;

    /**
     * @return Searches orders.
     */
    moveReservation(reservationId: number, blockId: number, row: number, seat: number): Promise<void>;

    /**
     * @return Searches orders.
     */
    reactivateReservation(reservationId: number): Promise<void>;

    /**
     * @return Returns orders for a concert series.
     */
    getOrdersForSeries(id: number): Promise<OrderDataDto[]>;

    /**
     * @return Returns orders for a concert.
     */
    getOrdersForConcert(id: number): Promise<ConcertOrdersDto>;
}

export class AdminControllerClient implements IAdminControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Returns all orders.
     */
    getAllOrders(): Promise<OrderDataDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/orders/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrders(_response);
        });
    }

    protected processGetAllOrders(response: Response): Promise<OrderDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDataDto[]>(null as any);
    }

    /**
     * @return Searches orders.
     */
    search(concertSeriesId: number, concertId: number, body: string): Promise<OrderDataDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/orders/search/{concertSeriesId}/{concertId}";
        if (concertSeriesId === undefined || concertSeriesId === null)
            throw new globalThis.Error("The parameter 'concertSeriesId' must be defined.");
        url_ = url_.replace("{concertSeriesId}", encodeURIComponent("" + concertSeriesId));
        if (concertId === undefined || concertId === null)
            throw new globalThis.Error("The parameter 'concertId' must be defined.");
        url_ = url_.replace("{concertId}", encodeURIComponent("" + concertId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<OrderDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(OrderDataDto.fromJS(item));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDataDto[]>(null as any);
    }

    /**
     * @return Set an order to payed or not payed.
     */
    setPayed(orderId: number, payed: boolean): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/setPayed/{orderId}/{payed}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (payed === undefined || payed === null)
            throw new globalThis.Error("The parameter 'payed' must be defined.");
        url_ = url_.replace("{payed}", encodeURIComponent("" + payed));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPayed(_response);
        });
    }

    protected processSetPayed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Set an order to canceled or not canceled.
     */
    setCanceled(orderId: number, canceled: boolean): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/setCanceled/{orderId}/{canceled}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (canceled === undefined || canceled === null)
            throw new globalThis.Error("The parameter 'canceled' must be defined.");
        url_ = url_.replace("{canceled}", encodeURIComponent("" + canceled));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCanceled(_response);
        });
    }

    protected processSetCanceled(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Set an order to payed or not payed.
     */
    deleteOrder(orderId: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/delete/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOrder(_response);
        });
    }

    protected processDeleteOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Searches orders.
     */
    updateTracingData(orderId: number, body: ContactTracingDataDto): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/updateTracingData/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTracingData(_response);
        });
    }

    protected processUpdateTracingData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Searches orders.
     */
    cancelOrder(orderId: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/cancelOrder/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelOrder(_response);
        });
    }

    protected processCancelOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Searches orders.
     */
    reactivateOrder(orderId: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/reactivateOrder/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReactivateOrder(_response);
        });
    }

    protected processReactivateOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Searches orders.
     */
    cancelReservation(reservationId: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/cancelReservation/{reservationId}";
        if (reservationId === undefined || reservationId === null)
            throw new globalThis.Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelReservation(_response);
        });
    }

    protected processCancelReservation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Searches orders.
     */
    moveReservation(reservationId: number, blockId: number, row: number, seat: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/moveReservation/{reservationId}/{blockId}/{rowId}/{seat}";
        if (reservationId === undefined || reservationId === null)
            throw new globalThis.Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        if (blockId === undefined || blockId === null)
            throw new globalThis.Error("The parameter 'blockId' must be defined.");
        url_ = url_.replace("{blockId}", encodeURIComponent("" + blockId));
        if (row === undefined || row === null)
            throw new globalThis.Error("The parameter 'row' must be defined.");
        url_ = url_.replace("{row}", encodeURIComponent("" + row));
        if (seat === undefined || seat === null)
            throw new globalThis.Error("The parameter 'seat' must be defined.");
        url_ = url_.replace("{seat}", encodeURIComponent("" + seat));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveReservation(_response);
        });
    }

    protected processMoveReservation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Searches orders.
     */
    reactivateReservation(reservationId: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/orders/reactivateReservation/{reservationId}";
        if (reservationId === undefined || reservationId === null)
            throw new globalThis.Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReactivateReservation(_response);
        });
    }

    protected processReactivateReservation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Returns orders for a concert series.
     */
    getOrdersForSeries(id: number): Promise<OrderDataDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/orders/series/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrdersForSeries(_response);
        });
    }

    protected processGetOrdersForSeries(response: Response): Promise<OrderDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDataDto[]>(null as any);
    }

    /**
     * @return Returns orders for a concert.
     */
    getOrdersForConcert(id: number): Promise<ConcertOrdersDto> {
        let url_ = this.baseUrl + "/tickets/admin/orders/concert/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrdersForConcert(_response);
        });
    }

    protected processGetOrdersForConcert(response: Response): Promise<ConcertOrdersDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertOrdersDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertOrdersDto>(null as any);
    }
}

export interface IConcertCatalogControllerClient {

    /**
     * @return Returns all concert series for admin catalog management.
     */
    getConcertSeries(): Promise<ConcertSeriesAdminDto[]>;

    /**
     * @return Creates a concert series.
     */
    createConcertSeries(body: UpsertConcertSeriesDto): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Returns one concert series by id.
     */
    getConcertSeriesById(id: number): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Updates a concert series.
     */
    updateConcertSeries(id: number, body: UpsertConcertSeriesDto): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Deletes a concert series.
     */
    deleteConcertSeries(id: number): Promise<void>;

    /**
     * @return Returns all concerts for admin catalog management.
     */
    getConcerts(): Promise<ConcertAdminDto[]>;

    /**
     * @return Creates a concert.
     */
    createConcert(body: UpsertConcertDto): Promise<ConcertAdminDto>;

    /**
     * @return Returns one concert by id.
     */
    getConcertById(id: number): Promise<ConcertAdminDto>;

    /**
     * @return Updates a concert.
     */
    updateConcert(id: number, body: UpsertConcertDto): Promise<ConcertAdminDto>;

    /**
     * @return Deletes a concert.
     */
    deleteConcert(id: number): Promise<void>;

    /**
     * @return Generates and stores a new early access guid for a concert.
     */
    generateConcertEarlyAccessGuid(id: number): Promise<ConcertAdminDto>;

    /**
     * @return Postpones a concert to unknown date and sets date to originalDate.
     */
    postponeConcertToUnknownDate(id: number): Promise<ConcertAdminDto>;

    /**
     * @return Returns all locations for admin catalog management.
     */
    getLocations(): Promise<LocationAdminDto[]>;

    /**
     * @return Creates a location.
     */
    createLocation(body: UpsertLocationDto): Promise<LocationAdminDto>;

    /**
     * @return Returns one location by id.
     */
    getLocationById(id: number): Promise<LocationAdminDto>;

    /**
     * @return Updates a location.
     */
    updateLocation(id: number, body: UpsertLocationDto): Promise<LocationAdminDto>;

    /**
     * @return Deletes a location.
     */
    deleteLocation(id: number): Promise<void>;

    /**
     * @return Returns all artists for admin catalog management.
     */
    getArtists(): Promise<ArtistDto[]>;

    /**
     * @return Returns all playlist albums for admin catalog management.
     */
    getAlbums(): Promise<PlaylistAlbumCatalogDto[]>;
}

export class ConcertCatalogControllerClient implements IConcertCatalogControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Returns all concert series for admin catalog management.
     */
    getConcertSeries(): Promise<ConcertSeriesAdminDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertSeries(_response);
        });
    }

    protected processGetConcertSeries(response: Response): Promise<ConcertSeriesAdminDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertSeriesAdminDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto[]>(null as any);
    }

    /**
     * @return Creates a concert series.
     */
    createConcertSeries(body: UpsertConcertSeriesDto): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConcertSeries(_response);
        });
    }

    protected processCreateConcertSeries(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ConcertSeriesAdminDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Returns one concert series by id.
     */
    getConcertSeriesById(id: number): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertSeriesById(_response);
        });
    }

    protected processGetConcertSeriesById(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertSeriesAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Updates a concert series.
     */
    updateConcertSeries(id: number, body: UpsertConcertSeriesDto): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConcertSeries(_response);
        });
    }

    protected processUpdateConcertSeries(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertSeriesAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Deletes a concert series.
     */
    deleteConcertSeries(id: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConcertSeries(_response);
        });
    }

    protected processDeleteConcertSeries(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Returns all concerts for admin catalog management.
     */
    getConcerts(): Promise<ConcertAdminDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcerts(_response);
        });
    }

    protected processGetConcerts(response: Response): Promise<ConcertAdminDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConcertAdminDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto[]>(null as any);
    }

    /**
     * @return Creates a concert.
     */
    createConcert(body: UpsertConcertDto): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConcert(_response);
        });
    }

    protected processCreateConcert(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ConcertAdminDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Returns one concert by id.
     */
    getConcertById(id: number): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConcertById(_response);
        });
    }

    protected processGetConcertById(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Updates a concert.
     */
    updateConcert(id: number, body: UpsertConcertDto): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConcert(_response);
        });
    }

    protected processUpdateConcert(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Deletes a concert.
     */
    deleteConcert(id: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConcert(_response);
        });
    }

    protected processDeleteConcert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Generates and stores a new early access guid for a concert.
     */
    generateConcertEarlyAccessGuid(id: number): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}/early-access-guid";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateConcertEarlyAccessGuid(_response);
        });
    }

    protected processGenerateConcertEarlyAccessGuid(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Postpones a concert to unknown date and sets date to originalDate.
     */
    postponeConcertToUnknownDate(id: number): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}/postpone-to-unknown-date";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostponeConcertToUnknownDate(_response);
        });
    }

    protected processPostponeConcertToUnknownDate(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Returns all locations for admin catalog management.
     */
    getLocations(): Promise<LocationAdminDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<LocationAdminDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationAdminDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationAdminDto[]>(null as any);
    }

    /**
     * @return Creates a location.
     */
    createLocation(body: UpsertLocationDto): Promise<LocationAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: Response): Promise<LocationAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LocationAdminDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationAdminDto>(null as any);
    }

    /**
     * @return Returns one location by id.
     */
    getLocationById(id: number): Promise<LocationAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationById(_response);
        });
    }

    protected processGetLocationById(response: Response): Promise<LocationAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationAdminDto>(null as any);
    }

    /**
     * @return Updates a location.
     */
    updateLocation(id: number, body: UpsertLocationDto): Promise<LocationAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: Response): Promise<LocationAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationAdminDto>(null as any);
    }

    /**
     * @return Deletes a location.
     */
    deleteLocation(id: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Returns all artists for admin catalog management.
     */
    getArtists(): Promise<ArtistDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/artists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArtists(_response);
        });
    }

    protected processGetArtists(response: Response): Promise<ArtistDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArtistDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistDto[]>(null as any);
    }

    /**
     * @return Returns all playlist albums for admin catalog management.
     */
    getAlbums(): Promise<PlaylistAlbumCatalogDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/albums";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlbums(_response);
        });
    }

    protected processGetAlbums(response: Response): Promise<PlaylistAlbumCatalogDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaylistAlbumCatalogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistAlbumCatalogDto[]>(null as any);
    }
}

export interface ICatalogMediaControllerClient {

    /**
     * @return Adds or replaces the banner image of a concert series.
     */
    addConcertSeriesBanner(id: number, body: UpdateConcertSeriesBannerDto): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Removes the banner image of a concert series.
     */
    removeConcertSeriesBanner(id: number): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Adds or replaces the picture image of a concert series.
     */
    addConcertSeriesPicture(id: number, body: UpdateConcertSeriesPictureDto): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Removes the picture image of a concert series.
     */
    removeConcertSeriesPicture(id: number): Promise<ConcertSeriesAdminDto>;

    /**
     * @return Adds one image to a concert.
     */
    addConcertImage(id: number, body: AddConcertImageDto): Promise<ConcertAdminDto>;

    /**
     * @return Removes one image from a concert by url.
     */
    removeConcertImage(id: number, body: RemoveConcertImageDto): Promise<ConcertAdminDto>;

    /**
     * @return Adds one image to a location.
     */
    addLocationImage(id: number, body: AddLocationImageDto): Promise<LocationAdminDto>;

    /**
     * @return Removes one image from a location by url.
     */
    removeLocationImage(id: number, body: RemoveLocationImageDto): Promise<LocationAdminDto>;
}

export class CatalogMediaControllerClient implements ICatalogMediaControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Adds or replaces the banner image of a concert series.
     */
    addConcertSeriesBanner(id: number, body: UpdateConcertSeriesBannerDto): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}/banner";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddConcertSeriesBanner(_response);
        });
    }

    protected processAddConcertSeriesBanner(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertSeriesAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Removes the banner image of a concert series.
     */
    removeConcertSeriesBanner(id: number): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}/banner";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveConcertSeriesBanner(_response);
        });
    }

    protected processRemoveConcertSeriesBanner(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertSeriesAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Adds or replaces the picture image of a concert series.
     */
    addConcertSeriesPicture(id: number, body: UpdateConcertSeriesPictureDto): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}/picture";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddConcertSeriesPicture(_response);
        });
    }

    protected processAddConcertSeriesPicture(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertSeriesAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Removes the picture image of a concert series.
     */
    removeConcertSeriesPicture(id: number): Promise<ConcertSeriesAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concert-series/{id}/picture";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveConcertSeriesPicture(_response);
        });
    }

    protected processRemoveConcertSeriesPicture(response: Response): Promise<ConcertSeriesAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertSeriesAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertSeriesAdminDto>(null as any);
    }

    /**
     * @return Adds one image to a concert.
     */
    addConcertImage(id: number, body: AddConcertImageDto): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}/images";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddConcertImage(_response);
        });
    }

    protected processAddConcertImage(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Removes one image from a concert by url.
     */
    removeConcertImage(id: number, body: RemoveConcertImageDto): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}/images";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveConcertImage(_response);
        });
    }

    protected processRemoveConcertImage(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Adds one image to a location.
     */
    addLocationImage(id: number, body: AddLocationImageDto): Promise<LocationAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations/{id}/images";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddLocationImage(_response);
        });
    }

    protected processAddLocationImage(response: Response): Promise<LocationAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationAdminDto>(null as any);
    }

    /**
     * @return Removes one image from a location by url.
     */
    removeLocationImage(id: number, body: RemoveLocationImageDto): Promise<LocationAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/locations/{id}/images";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveLocationImage(_response);
        });
    }

    protected processRemoveLocationImage(response: Response): Promise<LocationAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationAdminDto>(null as any);
    }
}

export interface IFileLibraryControllerClient {

    /**
     * @param file (optional) 
     * @param title (optional) 
     * @param comment (optional) 
     * @param category (optional) 
     * @return Uploads a file to the filesystem library.
     */
    uploadFile(file?: FileParameter | undefined, title?: string | undefined, comment?: string | undefined, category?: string | undefined): Promise<StoredFileDto>;

    /**
     * @param q (optional) 
     * @param sortBy (optional) 
     * @param order (optional) 
     * @param category (optional) 
     * @return Lists files with optional search and sorting.
     */
    listFiles(q?: string | undefined, sortBy?: SortBy | undefined, order?: Order | undefined, category?: string | undefined): Promise<StoredFileDto[]>;

    /**
     * @return Deletes file and metadata sidecar.
     */
    deleteFile(body: RemoveFileDto): Promise<void>;

    /**
     * @param sortBy (optional) 
     * @param order (optional) 
     * @param category (optional) 
     * @return Searches files with optional sorting.
     */
    searchFiles(q: string, sortBy?: SortBy2 | undefined, order?: Order2 | undefined, category?: string | undefined): Promise<StoredFileDto[]>;

    /**
     * @return Returns file metadata.
     */
    getFile(id: string): Promise<StoredFileDto>;

    /**
     * @return Streams file for browser view.
     */
    viewFile(id: string): Promise<void>;

    /**
     * @return Downloads file.
     */
    downloadFile(id: string): Promise<void>;
}

export class FileLibraryControllerClient implements IFileLibraryControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @param title (optional) 
     * @param comment (optional) 
     * @param category (optional) 
     * @return Uploads a file to the filesystem library.
     */
    uploadFile(file?: FileParameter | undefined, title?: string | undefined, comment?: string | undefined, category?: string | undefined): Promise<StoredFileDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (title === null || title === undefined)
            throw new globalThis.Error("The parameter 'title' cannot be null.");
        else
            content_.append("title", title.toString());
        if (comment === null || comment === undefined)
            throw new globalThis.Error("The parameter 'comment' cannot be null.");
        else
            content_.append("comment", comment.toString());
        if (category === null || category === undefined)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else
            content_.append("category", category.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: Response): Promise<StoredFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = StoredFileDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoredFileDto>(null as any);
    }

    /**
     * @param q (optional) 
     * @param sortBy (optional) 
     * @param order (optional) 
     * @param category (optional) 
     * @return Lists files with optional search and sorting.
     */
    listFiles(q?: string | undefined, sortBy?: SortBy | undefined, order?: Order | undefined, category?: string | undefined): Promise<StoredFileDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/files?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (order === null)
            throw new globalThis.Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFiles(_response);
        });
    }

    protected processListFiles(response: Response): Promise<StoredFileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoredFileDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoredFileDto[]>(null as any);
    }

    /**
     * @return Deletes file and metadata sidecar.
     */
    deleteFile(body: RemoveFileDto): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sortBy (optional) 
     * @param order (optional) 
     * @param category (optional) 
     * @return Searches files with optional sorting.
     */
    searchFiles(q: string, sortBy?: SortBy2 | undefined, order?: Order2 | undefined, category?: string | undefined): Promise<StoredFileDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/files/search?";
        if (q === undefined || q === null)
            throw new globalThis.Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (order === null)
            throw new globalThis.Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchFiles(_response);
        });
    }

    protected processSearchFiles(response: Response): Promise<StoredFileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoredFileDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoredFileDto[]>(null as any);
    }

    /**
     * @return Returns file metadata.
     */
    getFile(id: string): Promise<StoredFileDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<StoredFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoredFileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoredFileDto>(null as any);
    }

    /**
     * @return Streams file for browser view.
     */
    viewFile(id: string): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/files/{id}/view";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processViewFile(_response);
        });
    }

    protected processViewFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Downloads file.
     */
    downloadFile(id: string): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/files/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFileReferenceControllerClient {

    /**
     * @return Rebuilds the full file reference index from ticket catalog JSON data.
     */
    rebuild(): Promise<FileReferenceRebuildResultDto>;

    /**
     * @return Returns missing and orphaned file diagnostics based on indexed references and filesystem files.
     */
    audit(): Promise<FileReferenceAuditDto>;

    /**
     * @return Scans public media files and inserts missing entries into FileReferences with sourceType=Library.
     */
    importPublicMedia(): Promise<FileReferenceImportPublicResultDto>;

    /**
     * @return Migrates legacy JSON image fields (concert/location images and series banner/picture) to ImageLinks and clears those JSON columns.
     */
    migrateImageLinks(): Promise<ImageLinkMigrationResultDto>;

    /**
     * @return Indexes file links that are embedded in content/description JSON fields into ContentFileLinks without changing API payloads.
     */
    migrateContentLinks(): Promise<ContentFileLinkMigrationResultDto>;

    /**
     * @return Returns post-migration verification counts for ImageLinks, ContentFileLinks, FileReferences and remaining legacy JSON image fields.
     */
    migrationReport(): Promise<LinkMigrationReportDto>;
}

export class FileReferenceControllerClient implements IFileReferenceControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Rebuilds the full file reference index from ticket catalog JSON data.
     */
    rebuild(): Promise<FileReferenceRebuildResultDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/references/rebuild";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRebuild(_response);
        });
    }

    protected processRebuild(response: Response): Promise<FileReferenceRebuildResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileReferenceRebuildResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileReferenceRebuildResultDto>(null as any);
    }

    /**
     * @return Returns missing and orphaned file diagnostics based on indexed references and filesystem files.
     */
    audit(): Promise<FileReferenceAuditDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/references/audit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAudit(_response);
        });
    }

    protected processAudit(response: Response): Promise<FileReferenceAuditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileReferenceAuditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileReferenceAuditDto>(null as any);
    }

    /**
     * @return Scans public media files and inserts missing entries into FileReferences with sourceType=Library.
     */
    importPublicMedia(): Promise<FileReferenceImportPublicResultDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/references/import-public-media";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportPublicMedia(_response);
        });
    }

    protected processImportPublicMedia(response: Response): Promise<FileReferenceImportPublicResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileReferenceImportPublicResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileReferenceImportPublicResultDto>(null as any);
    }

    /**
     * @return Migrates legacy JSON image fields (concert/location images and series banner/picture) to ImageLinks and clears those JSON columns.
     */
    migrateImageLinks(): Promise<ImageLinkMigrationResultDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/references/migrate-image-links";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateImageLinks(_response);
        });
    }

    protected processMigrateImageLinks(response: Response): Promise<ImageLinkMigrationResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageLinkMigrationResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageLinkMigrationResultDto>(null as any);
    }

    /**
     * @return Indexes file links that are embedded in content/description JSON fields into ContentFileLinks without changing API payloads.
     */
    migrateContentLinks(): Promise<ContentFileLinkMigrationResultDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/references/migrate-content-links";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateContentLinks(_response);
        });
    }

    protected processMigrateContentLinks(response: Response): Promise<ContentFileLinkMigrationResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentFileLinkMigrationResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentFileLinkMigrationResultDto>(null as any);
    }

    /**
     * @return Returns post-migration verification counts for ImageLinks, ContentFileLinks, FileReferences and remaining legacy JSON image fields.
     */
    migrationReport(): Promise<LinkMigrationReportDto> {
        let url_ = this.baseUrl + "/tickets/admin/files/references/migration-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrationReport(_response);
        });
    }

    protected processMigrationReport(response: Response): Promise<LinkMigrationReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkMigrationReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkMigrationReportDto>(null as any);
    }
}

export interface IPlanCatalogControllerClient {

    /**
     * @return Updates plan mode on a concert: link, use, or unlink.
     */
    updateConcertPlan(id: number, body: UpdateConcertPlanDto): Promise<ConcertAdminDto>;

    /**
     * @return Creates a reusable plan-table template from the concert plan.
     */
    reuseConcertPlan(id: number, body: ReuseConcertPlanDto): Promise<PlanAdminDto>;

    /**
     * @return Returns all plans for admin catalog management.
     */
    getPlans(): Promise<PlanAdminDto[]>;

    /**
     * @return Creates a plan.
     */
    createPlan(body: UpsertPlanDto): Promise<PlanAdminDto>;

    /**
     * @return Returns one plan by id.
     */
    getPlanById(id: number): Promise<PlanAdminDto>;

    /**
     * @return Updates a plan.
     */
    updatePlan(id: number, body: UpsertPlanDto): Promise<PlanAdminDto>;

    /**
     * @return Deletes a plan.
     */
    deletePlan(id: number): Promise<void>;
}

export class PlanCatalogControllerClient implements IPlanCatalogControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Updates plan mode on a concert: link, use, or unlink.
     */
    updateConcertPlan(id: number, body: UpdateConcertPlanDto): Promise<ConcertAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}/plan";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConcertPlan(_response);
        });
    }

    protected processUpdateConcertPlan(response: Response): Promise<ConcertAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConcertAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConcertAdminDto>(null as any);
    }

    /**
     * @return Creates a reusable plan-table template from the concert plan.
     */
    reuseConcertPlan(id: number, body: ReuseConcertPlanDto): Promise<PlanAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/concerts/{id}/reuse-plan";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReuseConcertPlan(_response);
        });
    }

    protected processReuseConcertPlan(response: Response): Promise<PlanAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PlanAdminDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanAdminDto>(null as any);
    }

    /**
     * @return Returns all plans for admin catalog management.
     */
    getPlans(): Promise<PlanAdminDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/plans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlans(_response);
        });
    }

    protected processGetPlans(response: Response): Promise<PlanAdminDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanAdminDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanAdminDto[]>(null as any);
    }

    /**
     * @return Creates a plan.
     */
    createPlan(body: UpsertPlanDto): Promise<PlanAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/plans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePlan(_response);
        });
    }

    protected processCreatePlan(response: Response): Promise<PlanAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PlanAdminDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanAdminDto>(null as any);
    }

    /**
     * @return Returns one plan by id.
     */
    getPlanById(id: number): Promise<PlanAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/plans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlanById(_response);
        });
    }

    protected processGetPlanById(response: Response): Promise<PlanAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanAdminDto>(null as any);
    }

    /**
     * @return Updates a plan.
     */
    updatePlan(id: number, body: UpsertPlanDto): Promise<PlanAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/plans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePlan(_response);
        });
    }

    protected processUpdatePlan(response: Response): Promise<PlanAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanAdminDto>(null as any);
    }

    /**
     * @return Deletes a plan.
     */
    deletePlan(id: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/plans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePlan(_response);
        });
    }

    protected processDeletePlan(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPlaylistCatalogControllerClient {

    getPlaylists(): Promise<PlaylistAdminDto[]>;

    createPlaylist(body: UpsertPlaylistDto): Promise<PlaylistAdminDto>;

    getPlaylistById(id: number): Promise<PlaylistAdminDto>;

    updatePlaylist(id: number, body: UpsertPlaylistDto): Promise<PlaylistAdminDto>;

    deletePlaylist(id: number): Promise<void>;

    importPlaylist(file?: FileParameter | undefined, dryRun?: boolean | undefined): Promise<PlaylistImportResultDto>;
}

export class PlaylistCatalogControllerClient implements IPlaylistCatalogControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPlaylists(): Promise<PlaylistAdminDto[]> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/playlists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlaylists(_response);
        });
    }

    protected processGetPlaylists(response: Response): Promise<PlaylistAdminDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaylistAdminDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistAdminDto[]>(null as any);
    }

    createPlaylist(body: UpsertPlaylistDto): Promise<PlaylistAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/playlists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePlaylist(_response);
        });
    }

    protected processCreatePlaylist(response: Response): Promise<PlaylistAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PlaylistAdminDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistAdminDto>(null as any);
    }

    getPlaylistById(id: number): Promise<PlaylistAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/playlists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlaylistById(_response);
        });
    }

    protected processGetPlaylistById(response: Response): Promise<PlaylistAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaylistAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistAdminDto>(null as any);
    }

    updatePlaylist(id: number, body: UpsertPlaylistDto): Promise<PlaylistAdminDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/playlists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePlaylist(_response);
        });
    }

    protected processUpdatePlaylist(response: Response): Promise<PlaylistAdminDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaylistAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistAdminDto>(null as any);
    }

    deletePlaylist(id: number): Promise<void> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/playlists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePlaylist(_response);
        });
    }

    protected processDeletePlaylist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importPlaylist(file?: FileParameter | undefined, dryRun?: boolean | undefined): Promise<PlaylistImportResultDto> {
        let url_ = this.baseUrl + "/tickets/admin/catalog/playlists/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (dryRun === null || dryRun === undefined)
            throw new globalThis.Error("The parameter 'dryRun' cannot be null.");
        else
            content_.append("dryRun", dryRun.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportPlaylist(_response);
        });
    }

    protected processImportPlaylist(response: Response): Promise<PlaylistImportResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PlaylistImportResultDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistImportResultDto>(null as any);
    }
}

export interface IPlaylistPublicControllerClient {

    /**
     * @return Returns playlists ordered by newest first.
     */
    getPlaylists(): Promise<PlaylistDataDto[]>;

    /**
     * @return Returns the newest playlist.
     */
    getNewestPlaylist(): Promise<PlaylistDataDto>;

    /**
     * @return Returns the three newest playlists.
     */
    getNewestThreePlaylists(): Promise<PlaylistDataDto[]>;
}

export class PlaylistPublicControllerClient implements IPlaylistPublicControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Returns playlists ordered by newest first.
     */
    getPlaylists(): Promise<PlaylistDataDto[]> {
        let url_ = this.baseUrl + "/tickets/playlists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlaylists(_response);
        });
    }

    protected processGetPlaylists(response: Response): Promise<PlaylistDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaylistDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistDataDto[]>(null as any);
    }

    /**
     * @return Returns the newest playlist.
     */
    getNewestPlaylist(): Promise<PlaylistDataDto> {
        let url_ = this.baseUrl + "/tickets/playlists/newest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewestPlaylist(_response);
        });
    }

    protected processGetNewestPlaylist(response: Response): Promise<PlaylistDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaylistDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistDataDto>(null as any);
    }

    /**
     * @return Returns the three newest playlists.
     */
    getNewestThreePlaylists(): Promise<PlaylistDataDto[]> {
        let url_ = this.baseUrl + "/tickets/playlists/newest-three";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewestThreePlaylists(_response);
        });
    }

    protected processGetNewestThreePlaylists(response: Response): Promise<PlaylistDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaylistDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaylistDataDto[]>(null as any);
    }
}

export class EnvironmentDto implements IEnvironmentDto {
    configKey!: string;
    configEnvironment!: string;
    processEnvironment!: string;
    baseUrl!: string;
    apiUrl!: string;
    version!: string;

    [key: string]: any;

    constructor(data?: IEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configKey = _data["configKey"] !== undefined ? _data["configKey"] : null as any;
            this.configEnvironment = _data["configEnvironment"] !== undefined ? _data["configEnvironment"] : null as any;
            this.processEnvironment = _data["processEnvironment"] !== undefined ? _data["processEnvironment"] : null as any;
            this.baseUrl = _data["baseUrl"] !== undefined ? _data["baseUrl"] : null as any;
            this.apiUrl = _data["apiUrl"] !== undefined ? _data["apiUrl"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): EnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configKey"] = this.configKey !== undefined ? this.configKey : null as any;
        data["configEnvironment"] = this.configEnvironment !== undefined ? this.configEnvironment : null as any;
        data["processEnvironment"] = this.processEnvironment !== undefined ? this.processEnvironment : null as any;
        data["baseUrl"] = this.baseUrl !== undefined ? this.baseUrl : null as any;
        data["apiUrl"] = this.apiUrl !== undefined ? this.apiUrl : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export interface IEnvironmentDto {
    configKey: string;
    configEnvironment: string;
    processEnvironment: string;
    baseUrl: string;
    apiUrl: string;
    version: string;

    [key: string]: any;
}

export class CredentialsDto implements ICredentialsDto {
    email!: string;
    password!: string;

    [key: string]: any;

    constructor(data?: ICredentialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static fromJS(data: any): CredentialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        return data;
    }
}

export interface ICredentialsDto {
    email: string;
    password: string;

    [key: string]: any;
}

export class TokenDto implements ITokenDto {
    token!: string;
    validUntil!: DateTime;

    [key: string]: any;

    constructor(data?: ITokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"] !== undefined ? _data["token"] : null as any;
            this.validUntil = _data["validUntil"] ? DateTime.fromISO(_data["validUntil"].toString()) : null as any;
        }
    }

    static fromJS(data: any): TokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token !== undefined ? this.token : null as any;
        data["validUntil"] = this.validUntil ? this.validUntil.toString() : null as any;
        return data;
    }
}

export interface ITokenDto {
    token: string;
    validUntil: DateTime;

    [key: string]: any;
}

export class UserInfoDto implements IUserInfoDto {
    id!: number;
    firstName!: string;
    lastName!: string;
    roles!: string[];
    email!: string;

    [key: string]: any;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IUserInfoDto {
    id: number;
    firstName: string;
    lastName: string;
    roles: string[];
    email: string;

    [key: string]: any;
}

export class ChangePasswordRequestDto implements IChangePasswordRequestDto {
    email!: string;

    [key: string]: any;

    constructor(data?: IChangePasswordRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ChangePasswordRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IChangePasswordRequestDto {
    email: string;

    [key: string]: any;
}

export class MessageDto implements IMessageDto {
    code!: number;
    type!: MessageDtoType;
    text!: string;

    [key: string]: any;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IMessageDto {
    code: number;
    type: MessageDtoType;
    text: string;

    [key: string]: any;
}

export class ResponseDto implements IResponseDto {
    isSuccessful!: any;
    messages!: MessageDto[];

    [key: string]: any;

    constructor(data?: IResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.messages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSuccessful = _data["isSuccessful"] !== undefined ? _data["isSuccessful"] : null as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDto.fromJS(item));
            }
            else {
                this.messages = null as any;
            }
        }
    }

    static fromJS(data: any): ResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSuccessful"] = this.isSuccessful !== undefined ? this.isSuccessful : null as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IResponseDto {
    isSuccessful: any;
    messages: MessageDto[];

    [key: string]: any;
}

export class ChangePasswordDto implements IChangePasswordDto {
    guid!: string;
    password!: string;

    [key: string]: any;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        return data;
    }
}

export interface IChangePasswordDto {
    guid: string;
    password: string;

    [key: string]: any;
}

export class AmountReductionDto implements IAmountReductionDto {
    numberOfTickets!: number;
    reduction!: number;

    [key: string]: any;

    constructor(data?: IAmountReductionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.numberOfTickets = _data["numberOfTickets"] !== undefined ? _data["numberOfTickets"] : null as any;
            this.reduction = _data["reduction"] !== undefined ? _data["reduction"] : null as any;
        }
    }

    static fromJS(data: any): AmountReductionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmountReductionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["numberOfTickets"] = this.numberOfTickets !== undefined ? this.numberOfTickets : null as any;
        data["reduction"] = this.reduction !== undefined ? this.reduction : null as any;
        return data;
    }
}

export interface IAmountReductionDto {
    numberOfTickets: number;
    reduction: number;

    [key: string]: any;
}

export class RowPriceDependency implements IRowPriceDependency {
    row!: number;
    seats?: number[];

    [key: string]: any;

    constructor(data?: IRowPriceDependency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(item);
            }
            else {
                this.seats = null as any;
            }
        }
    }

    static fromJS(data: any): RowPriceDependency {
        data = typeof data === 'object' ? data : {};
        let result = new RowPriceDependency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["row"] = this.row !== undefined ? this.row : null as any;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item);
        }
        return data;
    }
}

export interface IRowPriceDependency {
    row: number;
    seats?: number[];

    [key: string]: any;
}

export class BlockPriceDependency implements IBlockPriceDependency {
    block!: number;
    rows?: RowPriceDependency[];

    [key: string]: any;

    constructor(data?: IBlockPriceDependency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.block = _data["block"] !== undefined ? _data["block"] : null as any;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowPriceDependency.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static fromJS(data: any): BlockPriceDependency {
        data = typeof data === 'object' ? data : {};
        let result = new BlockPriceDependency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["block"] = this.block !== undefined ? this.block : null as any;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBlockPriceDependency {
    block: number;
    rows?: RowPriceDependency[];

    [key: string]: any;
}

export class SaleOptionDto implements ISaleOptionDto {
    id!: number;
    text?: string;
    price!: number;
    dependencies?: BlockPriceDependency[];
    isAdditional?: boolean;
    isReducable?: boolean;
    dependsOn?: number;
    isDefault?: boolean;
    reduction?: AmountReductionDto;

    [key: string]: any;

    constructor(data?: ISaleOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.isAdditional = false;
            this.isReducable = false;
            this.isDefault = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["dependencies"])
                    this.dependencies!.push(BlockPriceDependency.fromJS(item));
            }
            else {
                this.dependencies = null as any;
            }
            this.isAdditional = _data["isAdditional"] !== undefined ? _data["isAdditional"] : false;
            this.isReducable = _data["isReducable"] !== undefined ? _data["isReducable"] : false;
            this.dependsOn = _data["dependsOn"] !== undefined ? _data["dependsOn"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : false;
            this.reduction = _data["reduction"] ? AmountReductionDto.fromJS(_data["reduction"]) : null as any;
        }
    }

    static fromJS(data: any): SaleOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item ? item.toJSON() : null as any);
        }
        data["isAdditional"] = this.isAdditional !== undefined ? this.isAdditional : null as any;
        data["isReducable"] = this.isReducable !== undefined ? this.isReducable : null as any;
        data["dependsOn"] = this.dependsOn !== undefined ? this.dependsOn : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["reduction"] = this.reduction ? this.reduction.toJSON() : null as any;
        return data;
    }
}

export interface ISaleOptionDto {
    id: number;
    text?: string;
    price: number;
    dependencies?: BlockPriceDependency[];
    isAdditional?: boolean;
    isReducable?: boolean;
    dependsOn?: number;
    isDefault?: boolean;
    reduction?: AmountReductionDto;

    [key: string]: any;
}

export class SaleOptionsDto implements ISaleOptionsDto {
    amountReductions?: AmountReductionDto[];
    options?: SaleOptionDto[];

    [key: string]: any;

    constructor(data?: ISaleOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["amountReductions"])) {
                this.amountReductions = [] as any;
                for (let item of _data["amountReductions"])
                    this.amountReductions!.push(AmountReductionDto.fromJS(item));
            }
            else {
                this.amountReductions = null as any;
            }
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SaleOptionDto.fromJS(item));
            }
            else {
                this.options = null as any;
            }
        }
    }

    static fromJS(data: any): SaleOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.amountReductions)) {
            data["amountReductions"] = [];
            for (let item of this.amountReductions)
                data["amountReductions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISaleOptionsDto {
    amountReductions?: AmountReductionDto[];
    options?: SaleOptionDto[];

    [key: string]: any;
}

export class RestrictionOptionsDto implements IRestrictionOptionsDto {
    requireContactTracing?: boolean;
    registerNamesOnly?: boolean;
    message?: MessageDto;

    [key: string]: any;

    constructor(data?: IRestrictionOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.requireContactTracing = false;
            this.registerNamesOnly = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requireContactTracing = _data["requireContactTracing"] !== undefined ? _data["requireContactTracing"] : false;
            this.registerNamesOnly = _data["registerNamesOnly"] !== undefined ? _data["registerNamesOnly"] : false;
            this.message = _data["message"] ? MessageDto.fromJS(_data["message"]) : null as any;
        }
    }

    static fromJS(data: any): RestrictionOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictionOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requireContactTracing"] = this.requireContactTracing !== undefined ? this.requireContactTracing : null as any;
        data["registerNamesOnly"] = this.registerNamesOnly !== undefined ? this.registerNamesOnly : null as any;
        data["message"] = this.message ? this.message.toJSON() : null as any;
        return data;
    }
}

export interface IRestrictionOptionsDto {
    requireContactTracing?: boolean;
    registerNamesOnly?: boolean;
    message?: MessageDto;

    [key: string]: any;
}

export class ImageDto implements IImageDto {
    image?: string;
    title?: string;
    comment?: string;
    url?: string;
    type?: ImageDtoType;

    [key: string]: any;

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["image"] = this.image !== undefined ? this.image : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IImageDto {
    image?: string;
    title?: string;
    comment?: string;
    url?: string;
    type?: ImageDtoType;

    [key: string]: any;
}

export class LinkDto implements ILinkDto {
    title?: string;
    url!: string;

    [key: string]: any;

    constructor(data?: ILinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): LinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface ILinkDto {
    title?: string;
    url: string;

    [key: string]: any;
}

export class LocationDto implements ILocationDto {
    images?: ImageDto[];
    links?: LinkDto[];
    name!: string;
    comment?: string;
    street?: string;
    zip?: string;
    city?: string;
    phone?: string;

    [key: string]: any;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        return data;
    }
}

export interface ILocationDto {
    images?: ImageDto[];
    links?: LinkDto[];
    name: string;
    comment?: string;
    street?: string;
    zip?: string;
    city?: string;
    phone?: string;

    [key: string]: any;
}

export class ArtistDto implements IArtistDto {
    id?: number;
    name!: string;
    description?: string;
    url?: string;
    images!: ImageDto[];
    links!: LinkDto[];

    [key: string]: any;

    constructor(data?: IArtistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.images = [];
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
        }
    }

    static fromJS(data: any): ArtistDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IArtistDto {
    id?: number;
    name: string;
    description?: string;
    url?: string;
    images: ImageDto[];
    links: LinkDto[];

    [key: string]: any;
}

export class AreaDto implements IAreaDto {
    row?: number;
    column?: number;
    colSpan?: number;
    rowSpan?: number;
    verticalAlign?: AreaDtoVerticalAlign;
    horizontalAlign?: AreaDtoHorizontalAlign;
    contentWidth?: string;
    comment?: string;
    rotation?: number;

    [key: string]: any;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.rotation = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.column = _data["column"] !== undefined ? _data["column"] : null as any;
            this.colSpan = _data["colSpan"] !== undefined ? _data["colSpan"] : null as any;
            this.rowSpan = _data["rowSpan"] !== undefined ? _data["rowSpan"] : null as any;
            this.verticalAlign = _data["verticalAlign"] !== undefined ? _data["verticalAlign"] : null as any;
            this.horizontalAlign = _data["horizontalAlign"] !== undefined ? _data["horizontalAlign"] : null as any;
            this.contentWidth = _data["contentWidth"] !== undefined ? _data["contentWidth"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.rotation = _data["rotation"] !== undefined ? _data["rotation"] : 0;
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["column"] = this.column !== undefined ? this.column : null as any;
        data["colSpan"] = this.colSpan !== undefined ? this.colSpan : null as any;
        data["rowSpan"] = this.rowSpan !== undefined ? this.rowSpan : null as any;
        data["verticalAlign"] = this.verticalAlign !== undefined ? this.verticalAlign : null as any;
        data["horizontalAlign"] = this.horizontalAlign !== undefined ? this.horizontalAlign : null as any;
        data["contentWidth"] = this.contentWidth !== undefined ? this.contentWidth : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["rotation"] = this.rotation !== undefined ? this.rotation : null as any;
        return data;
    }
}

export interface IAreaDto {
    row?: number;
    column?: number;
    colSpan?: number;
    rowSpan?: number;
    verticalAlign?: AreaDtoVerticalAlign;
    horizontalAlign?: AreaDtoHorizontalAlign;
    contentWidth?: string;
    comment?: string;
    rotation?: number;

    [key: string]: any;
}

export class SeatGap implements ISeatGap {
    seatToShift!: number;
    shiftNrOfGaps!: number;

    [key: string]: any;

    constructor(data?: ISeatGap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.seatToShift = _data["seatToShift"] !== undefined ? _data["seatToShift"] : null as any;
            this.shiftNrOfGaps = _data["shiftNrOfGaps"] !== undefined ? _data["shiftNrOfGaps"] : null as any;
        }
    }

    static fromJS(data: any): SeatGap {
        data = typeof data === 'object' ? data : {};
        let result = new SeatGap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["seatToShift"] = this.seatToShift !== undefined ? this.seatToShift : null as any;
        data["shiftNrOfGaps"] = this.shiftNrOfGaps !== undefined ? this.shiftNrOfGaps : null as any;
        return data;
    }
}

export interface ISeatGap {
    seatToShift: number;
    shiftNrOfGaps: number;

    [key: string]: any;
}

export class RowSettingsDto implements IRowSettingsDto {
    row!: number;
    startSeatNumbersAt?: number;
    seatCountDirection?: RowSettingsDtoSeatCountDirection;
    endSeatNumberAt?: number;
    removeSeats?: number[];
    gaps?: SeatGap[];
    skipRow?: boolean;
    addCorridorAfter?: boolean;
    blockRow?: boolean;
    blockSeats?: number[];

    [key: string]: any;

    constructor(data?: IRowSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.seatCountDirection = RowSettingsDtoSeatCountDirection.LikeBlockDefinition;
            this.skipRow = false;
            this.addCorridorAfter = false;
            this.blockRow = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.startSeatNumbersAt = _data["startSeatNumbersAt"] !== undefined ? _data["startSeatNumbersAt"] : null as any;
            this.seatCountDirection = _data["seatCountDirection"] !== undefined ? _data["seatCountDirection"] : RowSettingsDtoSeatCountDirection.LikeBlockDefinition;
            this.endSeatNumberAt = _data["endSeatNumberAt"] !== undefined ? _data["endSeatNumberAt"] : null as any;
            if (Array.isArray(_data["removeSeats"])) {
                this.removeSeats = [] as any;
                for (let item of _data["removeSeats"])
                    this.removeSeats!.push(item);
            }
            else {
                this.removeSeats = null as any;
            }
            if (Array.isArray(_data["gaps"])) {
                this.gaps = [] as any;
                for (let item of _data["gaps"])
                    this.gaps!.push(SeatGap.fromJS(item));
            }
            else {
                this.gaps = null as any;
            }
            this.skipRow = _data["skipRow"] !== undefined ? _data["skipRow"] : false;
            this.addCorridorAfter = _data["addCorridorAfter"] !== undefined ? _data["addCorridorAfter"] : false;
            this.blockRow = _data["blockRow"] !== undefined ? _data["blockRow"] : false;
            if (Array.isArray(_data["blockSeats"])) {
                this.blockSeats = [] as any;
                for (let item of _data["blockSeats"])
                    this.blockSeats!.push(item);
            }
            else {
                this.blockSeats = null as any;
            }
        }
    }

    static fromJS(data: any): RowSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["startSeatNumbersAt"] = this.startSeatNumbersAt !== undefined ? this.startSeatNumbersAt : null as any;
        data["seatCountDirection"] = this.seatCountDirection !== undefined ? this.seatCountDirection : null as any;
        data["endSeatNumberAt"] = this.endSeatNumberAt !== undefined ? this.endSeatNumberAt : null as any;
        if (Array.isArray(this.removeSeats)) {
            data["removeSeats"] = [];
            for (let item of this.removeSeats)
                data["removeSeats"].push(item);
        }
        if (Array.isArray(this.gaps)) {
            data["gaps"] = [];
            for (let item of this.gaps)
                data["gaps"].push(item ? item.toJSON() : null as any);
        }
        data["skipRow"] = this.skipRow !== undefined ? this.skipRow : null as any;
        data["addCorridorAfter"] = this.addCorridorAfter !== undefined ? this.addCorridorAfter : null as any;
        data["blockRow"] = this.blockRow !== undefined ? this.blockRow : null as any;
        if (Array.isArray(this.blockSeats)) {
            data["blockSeats"] = [];
            for (let item of this.blockSeats)
                data["blockSeats"].push(item);
        }
        return data;
    }
}

export interface IRowSettingsDto {
    row: number;
    startSeatNumbersAt?: number;
    seatCountDirection?: RowSettingsDtoSeatCountDirection;
    endSeatNumberAt?: number;
    removeSeats?: number[];
    gaps?: SeatGap[];
    skipRow?: boolean;
    addCorridorAfter?: boolean;
    blockRow?: boolean;
    blockSeats?: number[];

    [key: string]: any;
}

export class BlockDto implements IBlockDto {
    id!: number;
    name?: string;
    hideName?: boolean;
    area?: AreaDto;
    blockWideSeatCount?: boolean;
    seatCountDirection!: BlockDtoSeatCountDirection;
    numberOfRows!: number;
    seatsInRow!: number;
    startSeatNumbersAt?: number;
    hideSeatNr?: boolean;
    showSeatNrAtTheEnd?: boolean;
    hideRowNr?: boolean;
    showRowNrRight?: boolean;
    startRowsAt?: number;
    rowSettings?: RowSettingsDto[];
    blockAllSeats?: boolean;
    blockLayoutType?: BlockDtoBlockLayoutType;
    tableShape?: BlockDtoTableShape;
    tableSeatCount?: number;
    hasCenterTable?: boolean;
    centerTableLabel?: string;
    seatRotation?: number;

    [key: string]: any;

    constructor(data?: IBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.hideName = false;
            this.blockWideSeatCount = false;
            this.showSeatNrAtTheEnd = false;
            this.hideRowNr = false;
            this.showRowNrRight = false;
            this.blockAllSeats = false;
            this.blockLayoutType = BlockDtoBlockLayoutType.Rows;
            this.tableShape = BlockDtoTableShape.Round;
            this.tableSeatCount = 8;
            this.hasCenterTable = false;
            this.seatRotation = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.hideName = _data["hideName"] !== undefined ? _data["hideName"] : false;
            this.area = _data["area"] ? AreaDto.fromJS(_data["area"]) : null as any;
            this.blockWideSeatCount = _data["blockWideSeatCount"] !== undefined ? _data["blockWideSeatCount"] : false;
            this.seatCountDirection = _data["seatCountDirection"] !== undefined ? _data["seatCountDirection"] : null as any;
            this.numberOfRows = _data["numberOfRows"] !== undefined ? _data["numberOfRows"] : null as any;
            this.seatsInRow = _data["seatsInRow"] !== undefined ? _data["seatsInRow"] : null as any;
            this.startSeatNumbersAt = _data["startSeatNumbersAt"] !== undefined ? _data["startSeatNumbersAt"] : null as any;
            this.hideSeatNr = _data["hideSeatNr"] !== undefined ? _data["hideSeatNr"] : null as any;
            this.showSeatNrAtTheEnd = _data["showSeatNrAtTheEnd"] !== undefined ? _data["showSeatNrAtTheEnd"] : false;
            this.hideRowNr = _data["hideRowNr"] !== undefined ? _data["hideRowNr"] : false;
            this.showRowNrRight = _data["showRowNrRight"] !== undefined ? _data["showRowNrRight"] : false;
            this.startRowsAt = _data["startRowsAt"] !== undefined ? _data["startRowsAt"] : null as any;
            if (Array.isArray(_data["rowSettings"])) {
                this.rowSettings = [] as any;
                for (let item of _data["rowSettings"])
                    this.rowSettings!.push(RowSettingsDto.fromJS(item));
            }
            else {
                this.rowSettings = null as any;
            }
            this.blockAllSeats = _data["blockAllSeats"] !== undefined ? _data["blockAllSeats"] : false;
            this.blockLayoutType = _data["blockLayoutType"] !== undefined ? _data["blockLayoutType"] : BlockDtoBlockLayoutType.Rows;
            this.tableShape = _data["tableShape"] !== undefined ? _data["tableShape"] : BlockDtoTableShape.Round;
            this.tableSeatCount = _data["tableSeatCount"] !== undefined ? _data["tableSeatCount"] : 8;
            this.hasCenterTable = _data["hasCenterTable"] !== undefined ? _data["hasCenterTable"] : false;
            this.centerTableLabel = _data["centerTableLabel"] !== undefined ? _data["centerTableLabel"] : null as any;
            this.seatRotation = _data["seatRotation"] !== undefined ? _data["seatRotation"] : 0;
        }
    }

    static fromJS(data: any): BlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["hideName"] = this.hideName !== undefined ? this.hideName : null as any;
        data["area"] = this.area ? this.area.toJSON() : null as any;
        data["blockWideSeatCount"] = this.blockWideSeatCount !== undefined ? this.blockWideSeatCount : null as any;
        data["seatCountDirection"] = this.seatCountDirection !== undefined ? this.seatCountDirection : null as any;
        data["numberOfRows"] = this.numberOfRows !== undefined ? this.numberOfRows : null as any;
        data["seatsInRow"] = this.seatsInRow !== undefined ? this.seatsInRow : null as any;
        data["startSeatNumbersAt"] = this.startSeatNumbersAt !== undefined ? this.startSeatNumbersAt : null as any;
        data["hideSeatNr"] = this.hideSeatNr !== undefined ? this.hideSeatNr : null as any;
        data["showSeatNrAtTheEnd"] = this.showSeatNrAtTheEnd !== undefined ? this.showSeatNrAtTheEnd : null as any;
        data["hideRowNr"] = this.hideRowNr !== undefined ? this.hideRowNr : null as any;
        data["showRowNrRight"] = this.showRowNrRight !== undefined ? this.showRowNrRight : null as any;
        data["startRowsAt"] = this.startRowsAt !== undefined ? this.startRowsAt : null as any;
        if (Array.isArray(this.rowSettings)) {
            data["rowSettings"] = [];
            for (let item of this.rowSettings)
                data["rowSettings"].push(item ? item.toJSON() : null as any);
        }
        data["blockAllSeats"] = this.blockAllSeats !== undefined ? this.blockAllSeats : null as any;
        data["blockLayoutType"] = this.blockLayoutType !== undefined ? this.blockLayoutType : null as any;
        data["tableShape"] = this.tableShape !== undefined ? this.tableShape : null as any;
        data["tableSeatCount"] = this.tableSeatCount !== undefined ? this.tableSeatCount : null as any;
        data["hasCenterTable"] = this.hasCenterTable !== undefined ? this.hasCenterTable : null as any;
        data["centerTableLabel"] = this.centerTableLabel !== undefined ? this.centerTableLabel : null as any;
        data["seatRotation"] = this.seatRotation !== undefined ? this.seatRotation : null as any;
        return data;
    }
}

export interface IBlockDto {
    id: number;
    name?: string;
    hideName?: boolean;
    area?: AreaDto;
    blockWideSeatCount?: boolean;
    seatCountDirection: BlockDtoSeatCountDirection;
    numberOfRows: number;
    seatsInRow: number;
    startSeatNumbersAt?: number;
    hideSeatNr?: boolean;
    showSeatNrAtTheEnd?: boolean;
    hideRowNr?: boolean;
    showRowNrRight?: boolean;
    startRowsAt?: number;
    rowSettings?: RowSettingsDto[];
    blockAllSeats?: boolean;
    blockLayoutType?: BlockDtoBlockLayoutType;
    tableShape?: BlockDtoTableShape;
    tableSeatCount?: number;
    hasCenterTable?: boolean;
    centerTableLabel?: string;
    seatRotation?: number;

    [key: string]: any;
}

export class SeatDto implements ISeatDto {
    row!: number;
    seat!: number;

    [key: string]: any;

    constructor(data?: ISeatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.seat = _data["seat"] !== undefined ? _data["seat"] : null as any;
        }
    }

    static fromJS(data: any): SeatDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["seat"] = this.seat !== undefined ? this.seat : null as any;
        return data;
    }
}

export interface ISeatDto {
    row: number;
    seat: number;

    [key: string]: any;
}

export class RowRestrictionDto implements IRowRestrictionDto {
    row!: number;
    emptySeatsInBetween?: number;
    blockRow?: boolean;
    noRestriction?: boolean;
    blockSeats?: number[];

    [key: string]: any;

    constructor(data?: IRowRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.blockRow = false;
            this.noRestriction = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.emptySeatsInBetween = _data["emptySeatsInBetween"] !== undefined ? _data["emptySeatsInBetween"] : null as any;
            this.blockRow = _data["blockRow"] !== undefined ? _data["blockRow"] : false;
            this.noRestriction = _data["noRestriction"] !== undefined ? _data["noRestriction"] : false;
            if (Array.isArray(_data["blockSeats"])) {
                this.blockSeats = [] as any;
                for (let item of _data["blockSeats"])
                    this.blockSeats!.push(item);
            }
            else {
                this.blockSeats = null as any;
            }
        }
    }

    static fromJS(data: any): RowRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["emptySeatsInBetween"] = this.emptySeatsInBetween !== undefined ? this.emptySeatsInBetween : null as any;
        data["blockRow"] = this.blockRow !== undefined ? this.blockRow : null as any;
        data["noRestriction"] = this.noRestriction !== undefined ? this.noRestriction : null as any;
        if (Array.isArray(this.blockSeats)) {
            data["blockSeats"] = [];
            for (let item of this.blockSeats)
                data["blockSeats"].push(item);
        }
        return data;
    }
}

export interface IRowRestrictionDto {
    row: number;
    emptySeatsInBetween?: number;
    blockRow?: boolean;
    noRestriction?: boolean;
    blockSeats?: number[];

    [key: string]: any;
}

export class BlockRestrictionDto implements IBlockRestrictionDto {
    blockId!: number;
    blocked?: boolean;
    emptySeatsInBetween?: number;
    skipRowMode?: BlockRestrictionDtoSkipRowMode;
    blockSeats?: SeatDto[];
    rowRestrictions?: RowRestrictionDto[];
    noRestriction?: boolean;

    [key: string]: any;

    constructor(data?: IBlockRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.blocked = false;
            this.noRestriction = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.blockId = _data["blockId"] !== undefined ? _data["blockId"] : null as any;
            this.blocked = _data["blocked"] !== undefined ? _data["blocked"] : false;
            this.emptySeatsInBetween = _data["emptySeatsInBetween"] !== undefined ? _data["emptySeatsInBetween"] : null as any;
            this.skipRowMode = _data["skipRowMode"] !== undefined ? _data["skipRowMode"] : null as any;
            if (Array.isArray(_data["blockSeats"])) {
                this.blockSeats = [] as any;
                for (let item of _data["blockSeats"])
                    this.blockSeats!.push(SeatDto.fromJS(item));
            }
            else {
                this.blockSeats = null as any;
            }
            if (Array.isArray(_data["rowRestrictions"])) {
                this.rowRestrictions = [] as any;
                for (let item of _data["rowRestrictions"])
                    this.rowRestrictions!.push(RowRestrictionDto.fromJS(item));
            }
            else {
                this.rowRestrictions = null as any;
            }
            this.noRestriction = _data["noRestriction"] !== undefined ? _data["noRestriction"] : false;
        }
    }

    static fromJS(data: any): BlockRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["blockId"] = this.blockId !== undefined ? this.blockId : null as any;
        data["blocked"] = this.blocked !== undefined ? this.blocked : null as any;
        data["emptySeatsInBetween"] = this.emptySeatsInBetween !== undefined ? this.emptySeatsInBetween : null as any;
        data["skipRowMode"] = this.skipRowMode !== undefined ? this.skipRowMode : null as any;
        if (Array.isArray(this.blockSeats)) {
            data["blockSeats"] = [];
            for (let item of this.blockSeats)
                data["blockSeats"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.rowRestrictions)) {
            data["rowRestrictions"] = [];
            for (let item of this.rowRestrictions)
                data["rowRestrictions"].push(item ? item.toJSON() : null as any);
        }
        data["noRestriction"] = this.noRestriction !== undefined ? this.noRestriction : null as any;
        return data;
    }
}

export interface IBlockRestrictionDto {
    blockId: number;
    blocked?: boolean;
    emptySeatsInBetween?: number;
    skipRowMode?: BlockRestrictionDtoSkipRowMode;
    blockSeats?: SeatDto[];
    rowRestrictions?: RowRestrictionDto[];
    noRestriction?: boolean;

    [key: string]: any;
}

export class RestrictionDto implements IRestrictionDto {
    maxSeats?: number;
    seatsHaveToBeNextToEachOther?: boolean;
    emptySeatsInBetween?: number;
    skipRowMode?: RestrictionDtoSkipRowMode;
    blockRestrictions?: BlockRestrictionDto[];

    [key: string]: any;

    constructor(data?: IRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.seatsHaveToBeNextToEachOther = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.maxSeats = _data["maxSeats"] !== undefined ? _data["maxSeats"] : null as any;
            this.seatsHaveToBeNextToEachOther = _data["seatsHaveToBeNextToEachOther"] !== undefined ? _data["seatsHaveToBeNextToEachOther"] : false;
            this.emptySeatsInBetween = _data["emptySeatsInBetween"] !== undefined ? _data["emptySeatsInBetween"] : null as any;
            this.skipRowMode = _data["skipRowMode"] !== undefined ? _data["skipRowMode"] : null as any;
            if (Array.isArray(_data["blockRestrictions"])) {
                this.blockRestrictions = [] as any;
                for (let item of _data["blockRestrictions"])
                    this.blockRestrictions!.push(BlockRestrictionDto.fromJS(item));
            }
            else {
                this.blockRestrictions = null as any;
            }
        }
    }

    static fromJS(data: any): RestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["maxSeats"] = this.maxSeats !== undefined ? this.maxSeats : null as any;
        data["seatsHaveToBeNextToEachOther"] = this.seatsHaveToBeNextToEachOther !== undefined ? this.seatsHaveToBeNextToEachOther : null as any;
        data["emptySeatsInBetween"] = this.emptySeatsInBetween !== undefined ? this.emptySeatsInBetween : null as any;
        data["skipRowMode"] = this.skipRowMode !== undefined ? this.skipRowMode : null as any;
        if (Array.isArray(this.blockRestrictions)) {
            data["blockRestrictions"] = [];
            for (let item of this.blockRestrictions)
                data["blockRestrictions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IRestrictionDto {
    maxSeats?: number;
    seatsHaveToBeNextToEachOther?: boolean;
    emptySeatsInBetween?: number;
    skipRowMode?: RestrictionDtoSkipRowMode;
    blockRestrictions?: BlockRestrictionDto[];

    [key: string]: any;
}

export class PlanDto implements IPlanDto {
    id!: number;
    name!: string;
    blocks!: BlockDto[];
    stage?: AreaDto;
    mixer?: AreaDto;
    corridors?: AreaDto[];
    entrances?: AreaDto[];
    restrictions?: RestrictionDto;

    [key: string]: any;

    constructor(data?: IPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.blocks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(BlockDto.fromJS(item));
            }
            else {
                this.blocks = null as any;
            }
            this.stage = _data["stage"] ? AreaDto.fromJS(_data["stage"]) : null as any;
            this.mixer = _data["mixer"] ? AreaDto.fromJS(_data["mixer"]) : null as any;
            if (Array.isArray(_data["corridors"])) {
                this.corridors = [] as any;
                for (let item of _data["corridors"])
                    this.corridors!.push(AreaDto.fromJS(item));
            }
            else {
                this.corridors = null as any;
            }
            if (Array.isArray(_data["entrances"])) {
                this.entrances = [] as any;
                for (let item of _data["entrances"])
                    this.entrances!.push(AreaDto.fromJS(item));
            }
            else {
                this.entrances = null as any;
            }
            this.restrictions = _data["restrictions"] ? RestrictionDto.fromJS(_data["restrictions"]) : null as any;
        }
    }

    static fromJS(data: any): PlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item ? item.toJSON() : null as any);
        }
        data["stage"] = this.stage ? this.stage.toJSON() : null as any;
        data["mixer"] = this.mixer ? this.mixer.toJSON() : null as any;
        if (Array.isArray(this.corridors)) {
            data["corridors"] = [];
            for (let item of this.corridors)
                data["corridors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.entrances)) {
            data["entrances"] = [];
            for (let item of this.entrances)
                data["entrances"].push(item ? item.toJSON() : null as any);
        }
        data["restrictions"] = this.restrictions ? this.restrictions.toJSON() : null as any;
        return data;
    }
}

export interface IPlanDto {
    id: number;
    name: string;
    blocks: BlockDto[];
    stage?: AreaDto;
    mixer?: AreaDto;
    corridors?: AreaDto[];
    entrances?: AreaDto[];
    restrictions?: RestrictionDto;

    [key: string]: any;
}

export class CommentDto implements ICommentDto {
    title?: string;
    message!: string;
    className?: string;
    level?: CommentDtoLevel;
    commentType?: CommentDtoCommentType;

    [key: string]: any;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.className = _data["className"] !== undefined ? _data["className"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.commentType = _data["commentType"] !== undefined ? _data["commentType"] : null as any;
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["className"] = this.className !== undefined ? this.className : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["commentType"] = this.commentType !== undefined ? this.commentType : null as any;
        return data;
    }
}

export interface ICommentDto {
    title?: string;
    message: string;
    className?: string;
    level?: CommentDtoLevel;
    commentType?: CommentDtoCommentType;

    [key: string]: any;
}

export class ConcertDto implements IConcertDto {
    id!: number;
    concertSerieId?: number;
    title!: string;
    date?: DateTime;
    originalDate?: DateTime;
    start?: string;
    doors?: string;
    price!: number;
    ticketSale?: boolean;
    ticketSaleBlocked?: boolean;
    concertCancelled?: boolean;
    ticketSaleStart?: DateTime;
    ticketSaleEnd?: DateTime;
    soldOut?: boolean;
    saleOptions?: SaleOptionsDto;
    restrictionOptions?: RestrictionOptionsDto;
    location?: LocationDto;
    artists?: ArtistDto[];
    images?: ImageDto[];
    planId?: number;
    plan?: Plan | null;
    comments?: CommentDto[];
    postponedToUnknownDate?: boolean;
    hide?: boolean;

    [key: string]: any;

    constructor(data?: IConcertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.price = 50;
            this.ticketSale = false;
            this.ticketSaleBlocked = false;
            this.concertCancelled = false;
            this.soldOut = false;
            this.postponedToUnknownDate = false;
            this.hide = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.concertSerieId = _data["concertSerieId"] !== undefined ? _data["concertSerieId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : null as any;
            this.originalDate = _data["originalDate"] ? DateTime.fromISO(_data["originalDate"].toString()) : null as any;
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.doors = _data["doors"] !== undefined ? _data["doors"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : 50;
            this.ticketSale = _data["ticketSale"] !== undefined ? _data["ticketSale"] : false;
            this.ticketSaleBlocked = _data["ticketSaleBlocked"] !== undefined ? _data["ticketSaleBlocked"] : false;
            this.concertCancelled = _data["concertCancelled"] !== undefined ? _data["concertCancelled"] : false;
            this.ticketSaleStart = _data["ticketSaleStart"] ? DateTime.fromISO(_data["ticketSaleStart"].toString()) : null as any;
            this.ticketSaleEnd = _data["ticketSaleEnd"] ? DateTime.fromISO(_data["ticketSaleEnd"].toString()) : null as any;
            this.soldOut = _data["soldOut"] !== undefined ? _data["soldOut"] : false;
            this.saleOptions = _data["saleOptions"] ? SaleOptionsDto.fromJS(_data["saleOptions"]) : null as any;
            this.restrictionOptions = _data["restrictionOptions"] ? RestrictionOptionsDto.fromJS(_data["restrictionOptions"]) : null as any;
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : null as any;
            if (Array.isArray(_data["artists"])) {
                this.artists = [] as any;
                for (let item of _data["artists"])
                    this.artists!.push(ArtistDto.fromJS(item));
            }
            else {
                this.artists = null as any;
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            this.planId = _data["planId"] !== undefined ? _data["planId"] : null as any;
            this.plan = _data["plan"] ? Plan.fromJS(_data["plan"]) : null as any;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentDto.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            this.postponedToUnknownDate = _data["postponedToUnknownDate"] !== undefined ? _data["postponedToUnknownDate"] : false;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : false;
        }
    }

    static fromJS(data: any): ConcertDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConcertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["concertSerieId"] = this.concertSerieId !== undefined ? this.concertSerieId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["date"] = this.date ? this.date.toString() : null as any;
        data["originalDate"] = this.originalDate ? this.originalDate.toString() : null as any;
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["doors"] = this.doors !== undefined ? this.doors : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["ticketSale"] = this.ticketSale !== undefined ? this.ticketSale : null as any;
        data["ticketSaleBlocked"] = this.ticketSaleBlocked !== undefined ? this.ticketSaleBlocked : null as any;
        data["concertCancelled"] = this.concertCancelled !== undefined ? this.concertCancelled : null as any;
        data["ticketSaleStart"] = this.ticketSaleStart ? this.ticketSaleStart.toString() : null as any;
        data["ticketSaleEnd"] = this.ticketSaleEnd ? this.ticketSaleEnd.toString() : null as any;
        data["soldOut"] = this.soldOut !== undefined ? this.soldOut : null as any;
        data["saleOptions"] = this.saleOptions ? this.saleOptions.toJSON() : null as any;
        data["restrictionOptions"] = this.restrictionOptions ? this.restrictionOptions.toJSON() : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        if (Array.isArray(this.artists)) {
            data["artists"] = [];
            for (let item of this.artists)
                data["artists"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        data["planId"] = this.planId !== undefined ? this.planId : null as any;
        data["plan"] = this.plan ? this.plan.toJSON() : null as any;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        data["postponedToUnknownDate"] = this.postponedToUnknownDate !== undefined ? this.postponedToUnknownDate : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        return data;
    }
}

export interface IConcertDto {
    id: number;
    concertSerieId?: number;
    title: string;
    date?: DateTime;
    originalDate?: DateTime;
    start?: string;
    doors?: string;
    price: number;
    ticketSale?: boolean;
    ticketSaleBlocked?: boolean;
    concertCancelled?: boolean;
    ticketSaleStart?: DateTime;
    ticketSaleEnd?: DateTime;
    soldOut?: boolean;
    saleOptions?: SaleOptionsDto;
    restrictionOptions?: RestrictionOptionsDto;
    location?: LocationDto;
    artists?: ArtistDto[];
    images?: ImageDto[];
    planId?: number;
    plan?: Plan | null;
    comments?: CommentDto[];
    postponedToUnknownDate?: boolean;
    hide?: boolean;

    [key: string]: any;
}

export class ContentItemDto implements IContentItemDto {
    text?: string;
    url?: string;
    title?: string;
    header?: string;
    color?: string;
    images?: ImageDto[];
    type?: ContentItemDtoType;
    alertLevel?: ContentItemDtoAlertLevel;

    [key: string]: any;

    constructor(data?: IContentItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.header = _data["header"] !== undefined ? _data["header"] : null as any;
            this.color = _data["color"] !== undefined ? _data["color"] : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.alertLevel = _data["alertLevel"] !== undefined ? _data["alertLevel"] : null as any;
        }
    }

    static fromJS(data: any): ContentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["header"] = this.header !== undefined ? this.header : null as any;
        data["color"] = this.color !== undefined ? this.color : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["alertLevel"] = this.alertLevel !== undefined ? this.alertLevel : null as any;
        return data;
    }
}

export interface IContentItemDto {
    text?: string;
    url?: string;
    title?: string;
    header?: string;
    color?: string;
    images?: ImageDto[];
    type?: ContentItemDtoType;
    alertLevel?: ContentItemDtoAlertLevel;

    [key: string]: any;
}

export class ContentDto implements IContentDto {
    introduction?: string;
    artists?: ArtistDto[];
    paragraphs!: ContentItemDto[];
    highlight!: string[];

    [key: string]: any;

    constructor(data?: IContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.paragraphs = [];
            this.highlight = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.introduction = _data["introduction"] !== undefined ? _data["introduction"] : null as any;
            if (Array.isArray(_data["artists"])) {
                this.artists = [] as any;
                for (let item of _data["artists"])
                    this.artists!.push(ArtistDto.fromJS(item));
            }
            else {
                this.artists = null as any;
            }
            if (Array.isArray(_data["paragraphs"])) {
                this.paragraphs = [] as any;
                for (let item of _data["paragraphs"])
                    this.paragraphs!.push(ContentItemDto.fromJS(item));
            }
            else {
                this.paragraphs = null as any;
            }
            if (Array.isArray(_data["highlight"])) {
                this.highlight = [] as any;
                for (let item of _data["highlight"])
                    this.highlight!.push(item);
            }
            else {
                this.highlight = null as any;
            }
        }
    }

    static fromJS(data: any): ContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["introduction"] = this.introduction !== undefined ? this.introduction : null as any;
        if (Array.isArray(this.artists)) {
            data["artists"] = [];
            for (let item of this.artists)
                data["artists"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paragraphs)) {
            data["paragraphs"] = [];
            for (let item of this.paragraphs)
                data["paragraphs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.highlight)) {
            data["highlight"] = [];
            for (let item of this.highlight)
                data["highlight"].push(item);
        }
        return data;
    }
}

export interface IContentDto {
    introduction?: string;
    artists?: ArtistDto[];
    paragraphs: ContentItemDto[];
    highlight: string[];

    [key: string]: any;
}

export class ConcertSeriesDto implements IConcertSeriesDto {
    id!: number;
    title!: string;
    concerts!: ConcertDto[];
    artists?: ArtistDto[];
    ticketSaleStart?: DateTime;
    ticketSaleEnd?: DateTime;
    seriesStart?: DateTime;
    seriesEnd?: DateTime;
    hide?: boolean;
    hideConcerts?: boolean;
    comments?: CommentDto[];
    content?: ContentDto;
    picture?: ImageDto;
    banner?: ImageDto;
    links?: LinkDto[];

    [key: string]: any;

    constructor(data?: IConcertSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.concerts = [];
            this.hide = false;
            this.hideConcerts = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["concerts"])) {
                this.concerts = [] as any;
                for (let item of _data["concerts"])
                    this.concerts!.push(ConcertDto.fromJS(item));
            }
            else {
                this.concerts = null as any;
            }
            if (Array.isArray(_data["artists"])) {
                this.artists = [] as any;
                for (let item of _data["artists"])
                    this.artists!.push(ArtistDto.fromJS(item));
            }
            else {
                this.artists = null as any;
            }
            this.ticketSaleStart = _data["ticketSaleStart"] ? DateTime.fromISO(_data["ticketSaleStart"].toString()) : null as any;
            this.ticketSaleEnd = _data["ticketSaleEnd"] ? DateTime.fromISO(_data["ticketSaleEnd"].toString()) : null as any;
            this.seriesStart = _data["seriesStart"] ? DateTime.fromISO(_data["seriesStart"].toString()) : null as any;
            this.seriesEnd = _data["seriesEnd"] ? DateTime.fromISO(_data["seriesEnd"].toString()) : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : false;
            this.hideConcerts = _data["hideConcerts"] !== undefined ? _data["hideConcerts"] : false;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentDto.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            this.content = _data["content"] ? ContentDto.fromJS(_data["content"]) : null as any;
            this.picture = _data["picture"] ? ImageDto.fromJS(_data["picture"]) : null as any;
            this.banner = _data["banner"] ? ImageDto.fromJS(_data["banner"]) : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
        }
    }

    static fromJS(data: any): ConcertSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConcertSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.concerts)) {
            data["concerts"] = [];
            for (let item of this.concerts)
                data["concerts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.artists)) {
            data["artists"] = [];
            for (let item of this.artists)
                data["artists"].push(item ? item.toJSON() : null as any);
        }
        data["ticketSaleStart"] = this.ticketSaleStart ? this.ticketSaleStart.toString() : null as any;
        data["ticketSaleEnd"] = this.ticketSaleEnd ? this.ticketSaleEnd.toString() : null as any;
        data["seriesStart"] = this.seriesStart ? this.seriesStart.toString() : null as any;
        data["seriesEnd"] = this.seriesEnd ? this.seriesEnd.toString() : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["hideConcerts"] = this.hideConcerts !== undefined ? this.hideConcerts : null as any;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        data["content"] = this.content ? this.content.toJSON() : null as any;
        data["picture"] = this.picture ? this.picture.toJSON() : null as any;
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IConcertSeriesDto {
    id: number;
    title: string;
    concerts: ConcertDto[];
    artists?: ArtistDto[];
    ticketSaleStart?: DateTime;
    ticketSaleEnd?: DateTime;
    seriesStart?: DateTime;
    seriesEnd?: DateTime;
    hide?: boolean;
    hideConcerts?: boolean;
    comments?: CommentDto[];
    content?: ContentDto;
    picture?: ImageDto;
    banner?: ImageDto;
    links?: LinkDto[];

    [key: string]: any;
}

export class SeatReservationDto implements ISeatReservationDto {
    options?: SaleOptionDto[];
    price!: number;
    blockId!: number;
    blockName!: string;
    row!: number;
    seat!: number;

    [key: string]: any;

    constructor(data?: ISeatReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SaleOptionDto.fromJS(item));
            }
            else {
                this.options = null as any;
            }
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.blockId = _data["blockId"] !== undefined ? _data["blockId"] : null as any;
            this.blockName = _data["blockName"] !== undefined ? _data["blockName"] : null as any;
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.seat = _data["seat"] !== undefined ? _data["seat"] : null as any;
        }
    }

    static fromJS(data: any): SeatReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeatReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["blockId"] = this.blockId !== undefined ? this.blockId : null as any;
        data["blockName"] = this.blockName !== undefined ? this.blockName : null as any;
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["seat"] = this.seat !== undefined ? this.seat : null as any;
        return data;
    }
}

export interface ISeatReservationDto {
    options?: SaleOptionDto[];
    price: number;
    blockId: number;
    blockName: string;
    row: number;
    seat: number;

    [key: string]: any;
}

export class ReservationInfoDto implements IReservationInfoDto {
    concertSeries?: ConcertSeriesDto;
    concert!: ConcertDto;
    plan!: PlanDto;
    reservations!: SeatReservationDto[];

    [key: string]: any;

    constructor(data?: IReservationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.concert = new ConcertDto();
            this.plan = new PlanDto();
            this.reservations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.concertSeries = _data["concertSeries"] ? ConcertSeriesDto.fromJS(_data["concertSeries"]) : null as any;
            this.concert = _data["concert"] ? ConcertDto.fromJS(_data["concert"]) : new ConcertDto();
            this.plan = _data["plan"] ? PlanDto.fromJS(_data["plan"]) : new PlanDto();
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(SeatReservationDto.fromJS(item));
            }
            else {
                this.reservations = null as any;
            }
        }
    }

    static fromJS(data: any): ReservationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["concertSeries"] = this.concertSeries ? this.concertSeries.toJSON() : null as any;
        data["concert"] = this.concert ? this.concert.toJSON() : null as any;
        data["plan"] = this.plan ? this.plan.toJSON() : null as any;
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IReservationInfoDto {
    concertSeries?: ConcertSeriesDto;
    concert: ConcertDto;
    plan: PlanDto;
    reservations: SeatReservationDto[];

    [key: string]: any;
}

export class PersonDto implements IPersonDto {
    street?: string;
    zip?: string;
    city?: string;
    tel?: string;
    firstName!: string;
    lastName!: string;
    id!: number;
    email!: string;

    [key: string]: any;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.tel = _data["tel"] !== undefined ? _data["tel"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["tel"] = this.tel !== undefined ? this.tel : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IPersonDto {
    street?: string;
    zip?: string;
    city?: string;
    tel?: string;
    firstName: string;
    lastName: string;
    id: number;
    email: string;

    [key: string]: any;
}

export class ContactTracingInfoDto implements IContactTracingInfoDto {
    zip?: string;
    city?: string;
    street?: string;
    country?: string;
    tel?: string;
    firstName!: string;
    lastName!: string;

    [key: string]: any;

    constructor(data?: IContactTracingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.tel = _data["tel"] !== undefined ? _data["tel"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): ContactTracingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactTracingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["tel"] = this.tel !== undefined ? this.tel : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }
}

export interface IContactTracingInfoDto {
    zip?: string;
    city?: string;
    street?: string;
    country?: string;
    tel?: string;
    firstName: string;
    lastName: string;

    [key: string]: any;
}

export class ContactTracingDataDto implements IContactTracingDataDto {
    contacts!: ContactTracingInfoDto[];

    [key: string]: any;

    constructor(data?: IContactTracingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contacts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactTracingInfoDto.fromJS(item));
            }
            else {
                this.contacts = null as any;
            }
        }
    }

    static fromJS(data: any): ContactTracingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactTracingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IContactTracingDataDto {
    contacts: ContactTracingInfoDto[];

    [key: string]: any;
}

export class OrderDto implements IOrderDto {
    person!: PersonDto;
    reservations!: SeatReservationDto[];
    orderOk?: boolean;
    tracingData?: ContactTracingDataDto;

    [key: string]: any;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.person = new PersonDto();
            this.reservations = [];
            this.orderOk = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.person = _data["person"] ? PersonDto.fromJS(_data["person"]) : new PersonDto();
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(SeatReservationDto.fromJS(item));
            }
            else {
                this.reservations = null as any;
            }
            this.orderOk = _data["orderOk"] !== undefined ? _data["orderOk"] : false;
            this.tracingData = _data["tracingData"] ? ContactTracingDataDto.fromJS(_data["tracingData"]) : null as any;
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["person"] = this.person ? this.person.toJSON() : null as any;
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item ? item.toJSON() : null as any);
        }
        data["orderOk"] = this.orderOk !== undefined ? this.orderOk : null as any;
        data["tracingData"] = this.tracingData ? this.tracingData.toJSON() : null as any;
        return data;
    }
}

export interface IOrderDto {
    person: PersonDto;
    reservations: SeatReservationDto[];
    orderOk?: boolean;
    tracingData?: ContactTracingDataDto;

    [key: string]: any;
}

export class TicketInfoDto implements ITicketInfoDto {
    person!: PersonDto;
    seats!: SeatReservationDto[];
    payed?: boolean;
    aproved?: boolean;
    guid!: string;
    concert!: ConcertDto;
    tracingData!: ContactTracingDataDto;
    ticketCheckUrl!: string;

    [key: string]: any;

    constructor(data?: ITicketInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.person = new PersonDto();
            this.seats = [];
            this.payed = false;
            this.aproved = false;
            this.concert = new ConcertDto();
            this.tracingData = new ContactTracingDataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.person = _data["person"] ? PersonDto.fromJS(_data["person"]) : new PersonDto();
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(SeatReservationDto.fromJS(item));
            }
            else {
                this.seats = null as any;
            }
            this.payed = _data["payed"] !== undefined ? _data["payed"] : false;
            this.aproved = _data["aproved"] !== undefined ? _data["aproved"] : false;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.concert = _data["concert"] ? ConcertDto.fromJS(_data["concert"]) : new ConcertDto();
            this.tracingData = _data["tracingData"] ? ContactTracingDataDto.fromJS(_data["tracingData"]) : new ContactTracingDataDto();
            this.ticketCheckUrl = _data["ticketCheckUrl"] !== undefined ? _data["ticketCheckUrl"] : null as any;
        }
    }

    static fromJS(data: any): TicketInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["person"] = this.person ? this.person.toJSON() : null as any;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item ? item.toJSON() : null as any);
        }
        data["payed"] = this.payed !== undefined ? this.payed : null as any;
        data["aproved"] = this.aproved !== undefined ? this.aproved : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["concert"] = this.concert ? this.concert.toJSON() : null as any;
        data["tracingData"] = this.tracingData ? this.tracingData.toJSON() : null as any;
        data["ticketCheckUrl"] = this.ticketCheckUrl !== undefined ? this.ticketCheckUrl : null as any;
        return data;
    }
}

export interface ITicketInfoDto {
    person: PersonDto;
    seats: SeatReservationDto[];
    payed?: boolean;
    aproved?: boolean;
    guid: string;
    concert: ConcertDto;
    tracingData: ContactTracingDataDto;
    ticketCheckUrl: string;

    [key: string]: any;
}

export class TicketSaleCheckResponseDto implements ITicketSaleCheckResponseDto {
    canReserve!: boolean;
    message?: string;

    [key: string]: any;

    constructor(data?: ITicketSaleCheckResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.canReserve = _data["canReserve"] !== undefined ? _data["canReserve"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): TicketSaleCheckResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSaleCheckResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["canReserve"] = this.canReserve !== undefined ? this.canReserve : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export interface ITicketSaleCheckResponseDto {
    canReserve: boolean;
    message?: string;

    [key: string]: any;
}

export class OrderInfoDto implements IOrderInfoDto {
    person!: PersonDto;
    concertId!: number;
    reservations!: SeatReservationDto[];
    tracingData?: ContactTracingDataDto;
    earlyAccessGuid?: string;
    options?: SaleOptionDto[];

    [key: string]: any;

    constructor(data?: IOrderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.person = new PersonDto();
            this.reservations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.person = _data["person"] ? PersonDto.fromJS(_data["person"]) : new PersonDto();
            this.concertId = _data["concertId"] !== undefined ? _data["concertId"] : null as any;
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(SeatReservationDto.fromJS(item));
            }
            else {
                this.reservations = null as any;
            }
            this.tracingData = _data["tracingData"] ? ContactTracingDataDto.fromJS(_data["tracingData"]) : null as any;
            this.earlyAccessGuid = _data["earlyAccessGuid"] !== undefined ? _data["earlyAccessGuid"] : null as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SaleOptionDto.fromJS(item));
            }
            else {
                this.options = null as any;
            }
        }
    }

    static fromJS(data: any): OrderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["concertId"] = this.concertId !== undefined ? this.concertId : null as any;
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item ? item.toJSON() : null as any);
        }
        data["tracingData"] = this.tracingData ? this.tracingData.toJSON() : null as any;
        data["earlyAccessGuid"] = this.earlyAccessGuid !== undefined ? this.earlyAccessGuid : null as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOrderInfoDto {
    person: PersonDto;
    concertId: number;
    reservations: SeatReservationDto[];
    tracingData?: ContactTracingDataDto;
    earlyAccessGuid?: string;
    options?: SaleOptionDto[];

    [key: string]: any;
}

export class ReservationDataDto implements IReservationDataDto {
    id!: number;
    orderId!: number;
    order!: OrderDto;
    blockId!: number;
    row!: number;
    seat!: number;
    canceled?: boolean;
    dateCanceled?: DateTime;
    dateCreated!: DateTime;
    dateChanged?: DateTime;
    options?: SaleOptionDto[];
    price!: number;

    [key: string]: any;

    constructor(data?: IReservationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.order = new OrderDto();
            this.canceled = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : new OrderDto();
            this.blockId = _data["blockId"] !== undefined ? _data["blockId"] : null as any;
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.seat = _data["seat"] !== undefined ? _data["seat"] : null as any;
            this.canceled = _data["canceled"] !== undefined ? _data["canceled"] : false;
            this.dateCanceled = _data["dateCanceled"] ? DateTime.fromISO(_data["dateCanceled"].toString()) : null as any;
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SaleOptionDto.fromJS(item));
            }
            else {
                this.options = null as any;
            }
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
        }
    }

    static fromJS(data: any): ReservationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["order"] = this.order ? this.order.toJSON() : null as any;
        data["blockId"] = this.blockId !== undefined ? this.blockId : null as any;
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["seat"] = this.seat !== undefined ? this.seat : null as any;
        data["canceled"] = this.canceled !== undefined ? this.canceled : null as any;
        data["dateCanceled"] = this.dateCanceled ? this.dateCanceled.toString() : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        data["price"] = this.price !== undefined ? this.price : null as any;
        return data;
    }
}

export interface IReservationDataDto {
    id: number;
    orderId: number;
    order: OrderDto;
    blockId: number;
    row: number;
    seat: number;
    canceled?: boolean;
    dateCanceled?: DateTime;
    dateCreated: DateTime;
    dateChanged?: DateTime;
    options?: SaleOptionDto[];
    price: number;

    [key: string]: any;
}

export class OrderDataDto implements IOrderDataDto {
    id!: number;
    person!: PersonDto;
    userId!: number;
    concert!: ConcertDto;
    concertId!: number;
    reservations!: ReservationDataDto[];
    payed?: boolean;
    datePayed?: DateTime;
    canceled?: boolean;
    dateCanceled?: DateTime;
    approved?: boolean;
    dateApproved?: DateTime;
    contacts?: ContactTracingInfoDto[];
    dateCreated!: DateTime;
    dateChanged?: DateTime;
    guid!: string;
    price!: number;

    [key: string]: any;

    constructor(data?: IOrderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.person = new PersonDto();
            this.concert = new ConcertDto();
            this.reservations = [];
            this.payed = false;
            this.approved = false;
            this.price = 50;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.person = _data["person"] ? PersonDto.fromJS(_data["person"]) : new PersonDto();
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.concert = _data["concert"] ? ConcertDto.fromJS(_data["concert"]) : new ConcertDto();
            this.concertId = _data["concertId"] !== undefined ? _data["concertId"] : null as any;
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(ReservationDataDto.fromJS(item));
            }
            else {
                this.reservations = null as any;
            }
            this.payed = _data["payed"] !== undefined ? _data["payed"] : false;
            this.datePayed = _data["datePayed"] ? DateTime.fromISO(_data["datePayed"].toString()) : null as any;
            this.canceled = _data["canceled"] !== undefined ? _data["canceled"] : null as any;
            this.dateCanceled = _data["dateCanceled"] ? DateTime.fromISO(_data["dateCanceled"].toString()) : null as any;
            this.approved = _data["approved"] !== undefined ? _data["approved"] : false;
            this.dateApproved = _data["dateApproved"] ? DateTime.fromISO(_data["dateApproved"].toString()) : null as any;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactTracingInfoDto.fromJS(item));
            }
            else {
                this.contacts = null as any;
            }
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : 50;
        }
    }

    static fromJS(data: any): OrderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["concert"] = this.concert ? this.concert.toJSON() : null as any;
        data["concertId"] = this.concertId !== undefined ? this.concertId : null as any;
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item ? item.toJSON() : null as any);
        }
        data["payed"] = this.payed !== undefined ? this.payed : null as any;
        data["datePayed"] = this.datePayed ? this.datePayed.toString() : null as any;
        data["canceled"] = this.canceled !== undefined ? this.canceled : null as any;
        data["dateCanceled"] = this.dateCanceled ? this.dateCanceled.toString() : null as any;
        data["approved"] = this.approved !== undefined ? this.approved : null as any;
        data["dateApproved"] = this.dateApproved ? this.dateApproved.toString() : null as any;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : null as any);
        }
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        return data;
    }
}

export interface IOrderDataDto {
    id: number;
    person: PersonDto;
    userId: number;
    concert: ConcertDto;
    concertId: number;
    reservations: ReservationDataDto[];
    payed?: boolean;
    datePayed?: DateTime;
    canceled?: boolean;
    dateCanceled?: DateTime;
    approved?: boolean;
    dateApproved?: DateTime;
    contacts?: ContactTracingInfoDto[];
    dateCreated: DateTime;
    dateChanged?: DateTime;
    guid: string;
    price: number;

    [key: string]: any;
}

export class ConcertOrdersDto implements IConcertOrdersDto {
    concert!: ConcertDto;
    orders!: OrderDataDto[];

    [key: string]: any;

    constructor(data?: IConcertOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.concert = new ConcertDto();
            this.orders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.concert = _data["concert"] ? ConcertDto.fromJS(_data["concert"]) : new ConcertDto();
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderDataDto.fromJS(item));
            }
            else {
                this.orders = null as any;
            }
        }
    }

    static fromJS(data: any): ConcertOrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConcertOrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["concert"] = this.concert ? this.concert.toJSON() : null as any;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IConcertOrdersDto {
    concert: ConcertDto;
    orders: OrderDataDto[];

    [key: string]: any;
}

export class ConcertSeriesAdminDto implements IConcertSeriesAdminDto {
    title!: string;
    artistIds?: number[];
    comments?: CommentDto[];
    content?: ContentDto;
    links?: LinkDto[];
    ticketSaleStart?: DateTime | null;
    seriesStart?: DateTime | null;
    seriesEnd?: DateTime | null;
    hide?: boolean;
    hideConcerts?: boolean;
    id!: number;
    banner?: Banner | null;
    picture?: Picture | null;
    dateCreated!: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;

    constructor(data?: IConcertSeriesAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.hide = false;
            this.hideConcerts = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["artistIds"])) {
                this.artistIds = [] as any;
                for (let item of _data["artistIds"])
                    this.artistIds!.push(item);
            }
            else {
                this.artistIds = null as any;
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentDto.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            this.content = _data["content"] ? ContentDto.fromJS(_data["content"]) : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
            this.ticketSaleStart = _data["ticketSaleStart"] ? DateTime.fromISO(_data["ticketSaleStart"].toString()) : null as any;
            this.seriesStart = _data["seriesStart"] ? DateTime.fromISO(_data["seriesStart"].toString()) : null as any;
            this.seriesEnd = _data["seriesEnd"] ? DateTime.fromISO(_data["seriesEnd"].toString()) : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : false;
            this.hideConcerts = _data["hideConcerts"] !== undefined ? _data["hideConcerts"] : false;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.banner = _data["banner"] ? Banner.fromJS(_data["banner"]) : null as any;
            this.picture = _data["picture"] ? Picture.fromJS(_data["picture"]) : null as any;
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ConcertSeriesAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConcertSeriesAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.artistIds)) {
            data["artistIds"] = [];
            for (let item of this.artistIds)
                data["artistIds"].push(item);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        data["content"] = this.content ? this.content.toJSON() : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        data["ticketSaleStart"] = this.ticketSaleStart ? this.ticketSaleStart.toString() : null as any;
        data["seriesStart"] = this.seriesStart ? this.seriesStart.toString() : null as any;
        data["seriesEnd"] = this.seriesEnd ? this.seriesEnd.toString() : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["hideConcerts"] = this.hideConcerts !== undefined ? this.hideConcerts : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        data["picture"] = this.picture ? this.picture.toJSON() : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        return data;
    }
}

export interface IConcertSeriesAdminDto {
    title: string;
    artistIds?: number[];
    comments?: CommentDto[];
    content?: ContentDto;
    links?: LinkDto[];
    ticketSaleStart?: DateTime | null;
    seriesStart?: DateTime | null;
    seriesEnd?: DateTime | null;
    hide?: boolean;
    hideConcerts?: boolean;
    id: number;
    banner?: Banner | null;
    picture?: Picture | null;
    dateCreated: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;
}

export class UpsertConcertSeriesDto implements IUpsertConcertSeriesDto {
    title!: string;
    artistIds?: number[];
    comments?: CommentDto[];
    content?: ContentDto;
    links?: LinkDto[];
    ticketSaleStart?: DateTime | null;
    seriesStart?: DateTime | null;
    seriesEnd?: DateTime | null;
    hide?: boolean;
    hideConcerts?: boolean;

    [key: string]: any;

    constructor(data?: IUpsertConcertSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.hide = false;
            this.hideConcerts = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["artistIds"])) {
                this.artistIds = [] as any;
                for (let item of _data["artistIds"])
                    this.artistIds!.push(item);
            }
            else {
                this.artistIds = null as any;
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentDto.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            this.content = _data["content"] ? ContentDto.fromJS(_data["content"]) : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
            this.ticketSaleStart = _data["ticketSaleStart"] ? DateTime.fromISO(_data["ticketSaleStart"].toString()) : null as any;
            this.seriesStart = _data["seriesStart"] ? DateTime.fromISO(_data["seriesStart"].toString()) : null as any;
            this.seriesEnd = _data["seriesEnd"] ? DateTime.fromISO(_data["seriesEnd"].toString()) : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : false;
            this.hideConcerts = _data["hideConcerts"] !== undefined ? _data["hideConcerts"] : false;
        }
    }

    static fromJS(data: any): UpsertConcertSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertConcertSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.artistIds)) {
            data["artistIds"] = [];
            for (let item of this.artistIds)
                data["artistIds"].push(item);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        data["content"] = this.content ? this.content.toJSON() : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        data["ticketSaleStart"] = this.ticketSaleStart ? this.ticketSaleStart.toString() : null as any;
        data["seriesStart"] = this.seriesStart ? this.seriesStart.toString() : null as any;
        data["seriesEnd"] = this.seriesEnd ? this.seriesEnd.toString() : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["hideConcerts"] = this.hideConcerts !== undefined ? this.hideConcerts : null as any;
        return data;
    }
}

export interface IUpsertConcertSeriesDto {
    title: string;
    artistIds?: number[];
    comments?: CommentDto[];
    content?: ContentDto;
    links?: LinkDto[];
    ticketSaleStart?: DateTime | null;
    seriesStart?: DateTime | null;
    seriesEnd?: DateTime | null;
    hide?: boolean;
    hideConcerts?: boolean;

    [key: string]: any;
}

export class ConcertAdminDto implements IConcertAdminDto {
    concertSerieId?: number | null;
    date?: DateTime | null;
    doors?: string | null;
    start?: string | null;
    title!: string;
    artistTitle?: string | null;
    planId?: number | null;
    locationId?: number | null;
    saleOptions?: SaleOptionsDto;
    restrictionOptions?: RestrictionOptionsDto;
    comments?: CommentDto[];
    artistIds?: number[];
    ticketSaleStart?: DateTime | null;
    ticketSaleEnd?: DateTime | null;
    soldOut?: boolean;
    ticketSale?: boolean;
    ticketSaleBlocked?: boolean;
    concertCancelled?: boolean;
    price?: number | null;
    hide?: boolean;
    id!: number;
    plan?: Plan2 | null;
    originalDate?: DateTime | null;
    images?: ImageDto[];
    earlyAccessSaleGuid?: string | null;
    postponedToUnknownDate?: boolean;
    dateCreated!: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;

    constructor(data?: IConcertAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.soldOut = false;
            this.ticketSale = true;
            this.ticketSaleBlocked = false;
            this.concertCancelled = false;
            this.hide = false;
            this.postponedToUnknownDate = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.concertSerieId = _data["concertSerieId"] !== undefined ? _data["concertSerieId"] : null as any;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : null as any;
            this.doors = _data["doors"] !== undefined ? _data["doors"] : null as any;
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.artistTitle = _data["artistTitle"] !== undefined ? _data["artistTitle"] : null as any;
            this.planId = _data["planId"] !== undefined ? _data["planId"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.saleOptions = _data["saleOptions"] ? SaleOptionsDto.fromJS(_data["saleOptions"]) : null as any;
            this.restrictionOptions = _data["restrictionOptions"] ? RestrictionOptionsDto.fromJS(_data["restrictionOptions"]) : null as any;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentDto.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            if (Array.isArray(_data["artistIds"])) {
                this.artistIds = [] as any;
                for (let item of _data["artistIds"])
                    this.artistIds!.push(item);
            }
            else {
                this.artistIds = null as any;
            }
            this.ticketSaleStart = _data["ticketSaleStart"] ? DateTime.fromISO(_data["ticketSaleStart"].toString()) : null as any;
            this.ticketSaleEnd = _data["ticketSaleEnd"] ? DateTime.fromISO(_data["ticketSaleEnd"].toString()) : null as any;
            this.soldOut = _data["soldOut"] !== undefined ? _data["soldOut"] : false;
            this.ticketSale = _data["ticketSale"] !== undefined ? _data["ticketSale"] : true;
            this.ticketSaleBlocked = _data["ticketSaleBlocked"] !== undefined ? _data["ticketSaleBlocked"] : false;
            this.concertCancelled = _data["concertCancelled"] !== undefined ? _data["concertCancelled"] : false;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : false;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.plan = _data["plan"] ? Plan2.fromJS(_data["plan"]) : null as any;
            this.originalDate = _data["originalDate"] ? DateTime.fromISO(_data["originalDate"].toString()) : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            this.earlyAccessSaleGuid = _data["earlyAccessSaleGuid"] !== undefined ? _data["earlyAccessSaleGuid"] : null as any;
            this.postponedToUnknownDate = _data["postponedToUnknownDate"] !== undefined ? _data["postponedToUnknownDate"] : false;
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ConcertAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConcertAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["concertSerieId"] = this.concertSerieId !== undefined ? this.concertSerieId : null as any;
        data["date"] = this.date ? this.date.toString() : null as any;
        data["doors"] = this.doors !== undefined ? this.doors : null as any;
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["artistTitle"] = this.artistTitle !== undefined ? this.artistTitle : null as any;
        data["planId"] = this.planId !== undefined ? this.planId : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["saleOptions"] = this.saleOptions ? this.saleOptions.toJSON() : null as any;
        data["restrictionOptions"] = this.restrictionOptions ? this.restrictionOptions.toJSON() : null as any;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.artistIds)) {
            data["artistIds"] = [];
            for (let item of this.artistIds)
                data["artistIds"].push(item);
        }
        data["ticketSaleStart"] = this.ticketSaleStart ? this.ticketSaleStart.toString() : null as any;
        data["ticketSaleEnd"] = this.ticketSaleEnd ? this.ticketSaleEnd.toString() : null as any;
        data["soldOut"] = this.soldOut !== undefined ? this.soldOut : null as any;
        data["ticketSale"] = this.ticketSale !== undefined ? this.ticketSale : null as any;
        data["ticketSaleBlocked"] = this.ticketSaleBlocked !== undefined ? this.ticketSaleBlocked : null as any;
        data["concertCancelled"] = this.concertCancelled !== undefined ? this.concertCancelled : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["plan"] = this.plan ? this.plan.toJSON() : null as any;
        data["originalDate"] = this.originalDate ? this.originalDate.toString() : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        data["earlyAccessSaleGuid"] = this.earlyAccessSaleGuid !== undefined ? this.earlyAccessSaleGuid : null as any;
        data["postponedToUnknownDate"] = this.postponedToUnknownDate !== undefined ? this.postponedToUnknownDate : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        return data;
    }
}

export interface IConcertAdminDto {
    concertSerieId?: number | null;
    date?: DateTime | null;
    doors?: string | null;
    start?: string | null;
    title: string;
    artistTitle?: string | null;
    planId?: number | null;
    locationId?: number | null;
    saleOptions?: SaleOptionsDto;
    restrictionOptions?: RestrictionOptionsDto;
    comments?: CommentDto[];
    artistIds?: number[];
    ticketSaleStart?: DateTime | null;
    ticketSaleEnd?: DateTime | null;
    soldOut?: boolean;
    ticketSale?: boolean;
    ticketSaleBlocked?: boolean;
    concertCancelled?: boolean;
    price?: number | null;
    hide?: boolean;
    id: number;
    plan?: Plan2 | null;
    originalDate?: DateTime | null;
    images?: ImageDto[];
    earlyAccessSaleGuid?: string | null;
    postponedToUnknownDate?: boolean;
    dateCreated: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;
}

export class UpsertConcertDto implements IUpsertConcertDto {
    concertSerieId?: number | null;
    date?: DateTime | null;
    doors?: string | null;
    start?: string | null;
    title!: string;
    artistTitle?: string | null;
    planId?: number | null;
    locationId?: number | null;
    saleOptions?: SaleOptionsDto;
    restrictionOptions?: RestrictionOptionsDto;
    comments?: CommentDto[];
    artistIds?: number[];
    ticketSaleStart?: DateTime | null;
    ticketSaleEnd?: DateTime | null;
    soldOut?: boolean;
    ticketSale?: boolean;
    ticketSaleBlocked?: boolean;
    concertCancelled?: boolean;
    price?: number | null;
    hide?: boolean;

    [key: string]: any;

    constructor(data?: IUpsertConcertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.soldOut = false;
            this.ticketSale = true;
            this.ticketSaleBlocked = false;
            this.concertCancelled = false;
            this.hide = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.concertSerieId = _data["concertSerieId"] !== undefined ? _data["concertSerieId"] : null as any;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : null as any;
            this.doors = _data["doors"] !== undefined ? _data["doors"] : null as any;
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.artistTitle = _data["artistTitle"] !== undefined ? _data["artistTitle"] : null as any;
            this.planId = _data["planId"] !== undefined ? _data["planId"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.saleOptions = _data["saleOptions"] ? SaleOptionsDto.fromJS(_data["saleOptions"]) : null as any;
            this.restrictionOptions = _data["restrictionOptions"] ? RestrictionOptionsDto.fromJS(_data["restrictionOptions"]) : null as any;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentDto.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            if (Array.isArray(_data["artistIds"])) {
                this.artistIds = [] as any;
                for (let item of _data["artistIds"])
                    this.artistIds!.push(item);
            }
            else {
                this.artistIds = null as any;
            }
            this.ticketSaleStart = _data["ticketSaleStart"] ? DateTime.fromISO(_data["ticketSaleStart"].toString()) : null as any;
            this.ticketSaleEnd = _data["ticketSaleEnd"] ? DateTime.fromISO(_data["ticketSaleEnd"].toString()) : null as any;
            this.soldOut = _data["soldOut"] !== undefined ? _data["soldOut"] : false;
            this.ticketSale = _data["ticketSale"] !== undefined ? _data["ticketSale"] : true;
            this.ticketSaleBlocked = _data["ticketSaleBlocked"] !== undefined ? _data["ticketSaleBlocked"] : false;
            this.concertCancelled = _data["concertCancelled"] !== undefined ? _data["concertCancelled"] : false;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : false;
        }
    }

    static fromJS(data: any): UpsertConcertDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertConcertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["concertSerieId"] = this.concertSerieId !== undefined ? this.concertSerieId : null as any;
        data["date"] = this.date ? this.date.toString() : null as any;
        data["doors"] = this.doors !== undefined ? this.doors : null as any;
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["artistTitle"] = this.artistTitle !== undefined ? this.artistTitle : null as any;
        data["planId"] = this.planId !== undefined ? this.planId : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["saleOptions"] = this.saleOptions ? this.saleOptions.toJSON() : null as any;
        data["restrictionOptions"] = this.restrictionOptions ? this.restrictionOptions.toJSON() : null as any;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.artistIds)) {
            data["artistIds"] = [];
            for (let item of this.artistIds)
                data["artistIds"].push(item);
        }
        data["ticketSaleStart"] = this.ticketSaleStart ? this.ticketSaleStart.toString() : null as any;
        data["ticketSaleEnd"] = this.ticketSaleEnd ? this.ticketSaleEnd.toString() : null as any;
        data["soldOut"] = this.soldOut !== undefined ? this.soldOut : null as any;
        data["ticketSale"] = this.ticketSale !== undefined ? this.ticketSale : null as any;
        data["ticketSaleBlocked"] = this.ticketSaleBlocked !== undefined ? this.ticketSaleBlocked : null as any;
        data["concertCancelled"] = this.concertCancelled !== undefined ? this.concertCancelled : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        return data;
    }
}

export interface IUpsertConcertDto {
    concertSerieId?: number | null;
    date?: DateTime | null;
    doors?: string | null;
    start?: string | null;
    title: string;
    artistTitle?: string | null;
    planId?: number | null;
    locationId?: number | null;
    saleOptions?: SaleOptionsDto;
    restrictionOptions?: RestrictionOptionsDto;
    comments?: CommentDto[];
    artistIds?: number[];
    ticketSaleStart?: DateTime | null;
    ticketSaleEnd?: DateTime | null;
    soldOut?: boolean;
    ticketSale?: boolean;
    ticketSaleBlocked?: boolean;
    concertCancelled?: boolean;
    price?: number | null;
    hide?: boolean;

    [key: string]: any;
}

export class LocationAdminDto implements ILocationAdminDto {
    name!: string;
    description?: string | null;
    comment?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    links?: LinkDto[];
    id!: number;
    images?: ImageDto[];
    dateCreated!: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;

    constructor(data?: ILocationAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
        }
    }

    static fromJS(data: any): LocationAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        return data;
    }
}

export interface ILocationAdminDto {
    name: string;
    description?: string | null;
    comment?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    links?: LinkDto[];
    id: number;
    images?: ImageDto[];
    dateCreated: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;
}

export class UpsertLocationDto implements IUpsertLocationDto {
    name!: string;
    description?: string | null;
    comment?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    links?: LinkDto[];

    [key: string]: any;

    constructor(data?: IUpsertLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            else {
                this.links = null as any;
            }
        }
    }

    static fromJS(data: any): UpsertLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUpsertLocationDto {
    name: string;
    description?: string | null;
    comment?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    links?: LinkDto[];

    [key: string]: any;
}

export class PlaylistAlbumCatalogDto implements IPlaylistAlbumCatalogDto {
    id!: number;
    artistId!: number;
    artist!: string;
    title!: string;
    coverImageUrl?: string | null;

    [key: string]: any;

    constructor(data?: IPlaylistAlbumCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.artistId = _data["artistId"] !== undefined ? _data["artistId"] : null as any;
            this.artist = _data["artist"] !== undefined ? _data["artist"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : null as any;
        }
    }

    static fromJS(data: any): PlaylistAlbumCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistAlbumCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["artistId"] = this.artistId !== undefined ? this.artistId : null as any;
        data["artist"] = this.artist !== undefined ? this.artist : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : null as any;
        return data;
    }
}

export interface IPlaylistAlbumCatalogDto {
    id: number;
    artistId: number;
    artist: string;
    title: string;
    coverImageUrl?: string | null;

    [key: string]: any;
}

export class UpdateConcertSeriesBannerDto implements IUpdateConcertSeriesBannerDto {
    banner?: Banner2 | null;

    [key: string]: any;

    constructor(data?: IUpdateConcertSeriesBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.banner = _data["banner"] ? Banner2.fromJS(_data["banner"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateConcertSeriesBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConcertSeriesBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        return data;
    }
}

export interface IUpdateConcertSeriesBannerDto {
    banner?: Banner2 | null;

    [key: string]: any;
}

export class UpdateConcertSeriesPictureDto implements IUpdateConcertSeriesPictureDto {
    picture?: Picture2 | null;

    [key: string]: any;

    constructor(data?: IUpdateConcertSeriesPictureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.picture = _data["picture"] ? Picture2.fromJS(_data["picture"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateConcertSeriesPictureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConcertSeriesPictureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["picture"] = this.picture ? this.picture.toJSON() : null as any;
        return data;
    }
}

export interface IUpdateConcertSeriesPictureDto {
    picture?: Picture2 | null;

    [key: string]: any;
}

export class AddConcertImageDto implements IAddConcertImageDto {
    image!: ImageDto;

    [key: string]: any;

    constructor(data?: IAddConcertImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.image = new ImageDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : new ImageDto();
        }
    }

    static fromJS(data: any): AddConcertImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddConcertImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["image"] = this.image ? this.image.toJSON() : null as any;
        return data;
    }
}

export interface IAddConcertImageDto {
    image: ImageDto;

    [key: string]: any;
}

export class RemoveConcertImageDto implements IRemoveConcertImageDto {
    url!: string;

    [key: string]: any;

    constructor(data?: IRemoveConcertImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): RemoveConcertImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveConcertImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface IRemoveConcertImageDto {
    url: string;

    [key: string]: any;
}

export class AddLocationImageDto implements IAddLocationImageDto {
    image!: ImageDto;

    [key: string]: any;

    constructor(data?: IAddLocationImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.image = new ImageDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : new ImageDto();
        }
    }

    static fromJS(data: any): AddLocationImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddLocationImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["image"] = this.image ? this.image.toJSON() : null as any;
        return data;
    }
}

export interface IAddLocationImageDto {
    image: ImageDto;

    [key: string]: any;
}

export class RemoveLocationImageDto implements IRemoveLocationImageDto {
    url!: string;

    [key: string]: any;

    constructor(data?: IRemoveLocationImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): RemoveLocationImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveLocationImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface IRemoveLocationImageDto {
    url: string;

    [key: string]: any;
}

export class StoredFileDto implements IStoredFileDto {
    id!: string;
    fileName!: string;
    originalName!: string;
    mimeType!: string;
    size!: number;
    title?: string;
    comment?: string;
    category?: string;
    createdAt!: string;
    updatedAt!: string;
    publicUrl!: string;
    viewUrl!: string;
    downloadUrl!: string;

    [key: string]: any;

    constructor(data?: IStoredFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.originalName = _data["originalName"] !== undefined ? _data["originalName"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.publicUrl = _data["publicUrl"] !== undefined ? _data["publicUrl"] : null as any;
            this.viewUrl = _data["viewUrl"] !== undefined ? _data["viewUrl"] : null as any;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : null as any;
        }
    }

    static fromJS(data: any): StoredFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoredFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["originalName"] = this.originalName !== undefined ? this.originalName : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["publicUrl"] = this.publicUrl !== undefined ? this.publicUrl : null as any;
        data["viewUrl"] = this.viewUrl !== undefined ? this.viewUrl : null as any;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : null as any;
        return data;
    }
}

export interface IStoredFileDto {
    id: string;
    fileName: string;
    originalName: string;
    mimeType: string;
    size: number;
    title?: string;
    comment?: string;
    category?: string;
    createdAt: string;
    updatedAt: string;
    publicUrl: string;
    viewUrl: string;
    downloadUrl: string;

    [key: string]: any;
}

export class RemoveFileDto implements IRemoveFileDto {
    id!: string;

    [key: string]: any;

    constructor(data?: IRemoveFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): RemoveFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRemoveFileDto {
    id: string;

    [key: string]: any;
}

export class FileReferenceRebuildResultDto implements IFileReferenceRebuildResultDto {
    scannedSourceCount!: number;
    indexedReferenceCount!: number;

    [key: string]: any;

    constructor(data?: IFileReferenceRebuildResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.scannedSourceCount = _data["scannedSourceCount"] !== undefined ? _data["scannedSourceCount"] : null as any;
            this.indexedReferenceCount = _data["indexedReferenceCount"] !== undefined ? _data["indexedReferenceCount"] : null as any;
        }
    }

    static fromJS(data: any): FileReferenceRebuildResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileReferenceRebuildResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["scannedSourceCount"] = this.scannedSourceCount !== undefined ? this.scannedSourceCount : null as any;
        data["indexedReferenceCount"] = this.indexedReferenceCount !== undefined ? this.indexedReferenceCount : null as any;
        return data;
    }
}

export interface IFileReferenceRebuildResultDto {
    scannedSourceCount: number;
    indexedReferenceCount: number;

    [key: string]: any;
}

export class FileReferenceDto implements IFileReferenceDto {
    sourceType!: string;
    sourceId!: number;
    sourcePath!: string;
    referenceValue!: string;
    normalizedPath?: string | null;
    fileName?: string | null;
    fileId?: string | null;

    [key: string]: any;

    constructor(data?: IFileReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.sourcePath = _data["sourcePath"] !== undefined ? _data["sourcePath"] : null as any;
            this.referenceValue = _data["referenceValue"] !== undefined ? _data["referenceValue"] : null as any;
            this.normalizedPath = _data["normalizedPath"] !== undefined ? _data["normalizedPath"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : null as any;
        }
    }

    static fromJS(data: any): FileReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["sourcePath"] = this.sourcePath !== undefined ? this.sourcePath : null as any;
        data["referenceValue"] = this.referenceValue !== undefined ? this.referenceValue : null as any;
        data["normalizedPath"] = this.normalizedPath !== undefined ? this.normalizedPath : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileId"] = this.fileId !== undefined ? this.fileId : null as any;
        return data;
    }
}

export interface IFileReferenceDto {
    sourceType: string;
    sourceId: number;
    sourcePath: string;
    referenceValue: string;
    normalizedPath?: string | null;
    fileName?: string | null;
    fileId?: string | null;

    [key: string]: any;
}

export class MissingFileAuditItemDto implements IMissingFileAuditItemDto {
    fileName!: string;
    expectedPublicUrl!: string;
    references!: FileReferenceDto[];

    [key: string]: any;

    constructor(data?: IMissingFileAuditItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.references = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.expectedPublicUrl = _data["expectedPublicUrl"] !== undefined ? _data["expectedPublicUrl"] : null as any;
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(FileReferenceDto.fromJS(item));
            }
            else {
                this.references = null as any;
            }
        }
    }

    static fromJS(data: any): MissingFileAuditItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissingFileAuditItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["expectedPublicUrl"] = this.expectedPublicUrl !== undefined ? this.expectedPublicUrl : null as any;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMissingFileAuditItemDto {
    fileName: string;
    expectedPublicUrl: string;
    references: FileReferenceDto[];

    [key: string]: any;
}

export class OrphanFileAuditItemDto implements IOrphanFileAuditItemDto {
    fileName!: string;
    publicUrl!: string;

    [key: string]: any;

    constructor(data?: IOrphanFileAuditItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.publicUrl = _data["publicUrl"] !== undefined ? _data["publicUrl"] : null as any;
        }
    }

    static fromJS(data: any): OrphanFileAuditItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrphanFileAuditItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["publicUrl"] = this.publicUrl !== undefined ? this.publicUrl : null as any;
        return data;
    }
}

export interface IOrphanFileAuditItemDto {
    fileName: string;
    publicUrl: string;

    [key: string]: any;
}

export class FileReferenceAuditDto implements IFileReferenceAuditDto {
    referenceCount!: number;
    referencedFileCount!: number;
    storedFileCount!: number;
    missingFileCount!: number;
    orphanFileCount!: number;
    missingFiles!: MissingFileAuditItemDto[];
    orphanFiles!: OrphanFileAuditItemDto[];

    [key: string]: any;

    constructor(data?: IFileReferenceAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.missingFiles = [];
            this.orphanFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.referenceCount = _data["referenceCount"] !== undefined ? _data["referenceCount"] : null as any;
            this.referencedFileCount = _data["referencedFileCount"] !== undefined ? _data["referencedFileCount"] : null as any;
            this.storedFileCount = _data["storedFileCount"] !== undefined ? _data["storedFileCount"] : null as any;
            this.missingFileCount = _data["missingFileCount"] !== undefined ? _data["missingFileCount"] : null as any;
            this.orphanFileCount = _data["orphanFileCount"] !== undefined ? _data["orphanFileCount"] : null as any;
            if (Array.isArray(_data["missingFiles"])) {
                this.missingFiles = [] as any;
                for (let item of _data["missingFiles"])
                    this.missingFiles!.push(MissingFileAuditItemDto.fromJS(item));
            }
            else {
                this.missingFiles = null as any;
            }
            if (Array.isArray(_data["orphanFiles"])) {
                this.orphanFiles = [] as any;
                for (let item of _data["orphanFiles"])
                    this.orphanFiles!.push(OrphanFileAuditItemDto.fromJS(item));
            }
            else {
                this.orphanFiles = null as any;
            }
        }
    }

    static fromJS(data: any): FileReferenceAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileReferenceAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["referenceCount"] = this.referenceCount !== undefined ? this.referenceCount : null as any;
        data["referencedFileCount"] = this.referencedFileCount !== undefined ? this.referencedFileCount : null as any;
        data["storedFileCount"] = this.storedFileCount !== undefined ? this.storedFileCount : null as any;
        data["missingFileCount"] = this.missingFileCount !== undefined ? this.missingFileCount : null as any;
        data["orphanFileCount"] = this.orphanFileCount !== undefined ? this.orphanFileCount : null as any;
        if (Array.isArray(this.missingFiles)) {
            data["missingFiles"] = [];
            for (let item of this.missingFiles)
                data["missingFiles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.orphanFiles)) {
            data["orphanFiles"] = [];
            for (let item of this.orphanFiles)
                data["orphanFiles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFileReferenceAuditDto {
    referenceCount: number;
    referencedFileCount: number;
    storedFileCount: number;
    missingFileCount: number;
    orphanFileCount: number;
    missingFiles: MissingFileAuditItemDto[];
    orphanFiles: OrphanFileAuditItemDto[];

    [key: string]: any;
}

export class FileReferenceImportPublicResultDto implements IFileReferenceImportPublicResultDto {
    scannedFileCount!: number;
    createdReferenceCount!: number;
    existingReferenceCount!: number;

    [key: string]: any;

    constructor(data?: IFileReferenceImportPublicResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.scannedFileCount = _data["scannedFileCount"] !== undefined ? _data["scannedFileCount"] : null as any;
            this.createdReferenceCount = _data["createdReferenceCount"] !== undefined ? _data["createdReferenceCount"] : null as any;
            this.existingReferenceCount = _data["existingReferenceCount"] !== undefined ? _data["existingReferenceCount"] : null as any;
        }
    }

    static fromJS(data: any): FileReferenceImportPublicResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileReferenceImportPublicResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["scannedFileCount"] = this.scannedFileCount !== undefined ? this.scannedFileCount : null as any;
        data["createdReferenceCount"] = this.createdReferenceCount !== undefined ? this.createdReferenceCount : null as any;
        data["existingReferenceCount"] = this.existingReferenceCount !== undefined ? this.existingReferenceCount : null as any;
        return data;
    }
}

export interface IFileReferenceImportPublicResultDto {
    scannedFileCount: number;
    createdReferenceCount: number;
    existingReferenceCount: number;

    [key: string]: any;
}

export class ImageLinkMigrationResultDto implements IImageLinkMigrationResultDto {
    migratedConcertCount!: number;
    migratedConcertSeriesCount!: number;
    migratedLocationCount!: number;
    insertedLinkCount!: number;
    clearedLegacyJsonFields!: boolean;

    [key: string]: any;

    constructor(data?: IImageLinkMigrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.migratedConcertCount = _data["migratedConcertCount"] !== undefined ? _data["migratedConcertCount"] : null as any;
            this.migratedConcertSeriesCount = _data["migratedConcertSeriesCount"] !== undefined ? _data["migratedConcertSeriesCount"] : null as any;
            this.migratedLocationCount = _data["migratedLocationCount"] !== undefined ? _data["migratedLocationCount"] : null as any;
            this.insertedLinkCount = _data["insertedLinkCount"] !== undefined ? _data["insertedLinkCount"] : null as any;
            this.clearedLegacyJsonFields = _data["clearedLegacyJsonFields"] !== undefined ? _data["clearedLegacyJsonFields"] : null as any;
        }
    }

    static fromJS(data: any): ImageLinkMigrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageLinkMigrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["migratedConcertCount"] = this.migratedConcertCount !== undefined ? this.migratedConcertCount : null as any;
        data["migratedConcertSeriesCount"] = this.migratedConcertSeriesCount !== undefined ? this.migratedConcertSeriesCount : null as any;
        data["migratedLocationCount"] = this.migratedLocationCount !== undefined ? this.migratedLocationCount : null as any;
        data["insertedLinkCount"] = this.insertedLinkCount !== undefined ? this.insertedLinkCount : null as any;
        data["clearedLegacyJsonFields"] = this.clearedLegacyJsonFields !== undefined ? this.clearedLegacyJsonFields : null as any;
        return data;
    }
}

export interface IImageLinkMigrationResultDto {
    migratedConcertCount: number;
    migratedConcertSeriesCount: number;
    migratedLocationCount: number;
    insertedLinkCount: number;
    clearedLegacyJsonFields: boolean;

    [key: string]: any;
}

export class ContentFileLinkMigrationResultDto implements IContentFileLinkMigrationResultDto {
    scannedSourceCount!: number;
    indexedReferenceCount!: number;

    [key: string]: any;

    constructor(data?: IContentFileLinkMigrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.scannedSourceCount = _data["scannedSourceCount"] !== undefined ? _data["scannedSourceCount"] : null as any;
            this.indexedReferenceCount = _data["indexedReferenceCount"] !== undefined ? _data["indexedReferenceCount"] : null as any;
        }
    }

    static fromJS(data: any): ContentFileLinkMigrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentFileLinkMigrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["scannedSourceCount"] = this.scannedSourceCount !== undefined ? this.scannedSourceCount : null as any;
        data["indexedReferenceCount"] = this.indexedReferenceCount !== undefined ? this.indexedReferenceCount : null as any;
        return data;
    }
}

export interface IContentFileLinkMigrationResultDto {
    scannedSourceCount: number;
    indexedReferenceCount: number;

    [key: string]: any;
}

export class SourceCountDto implements ISourceCountDto {
    sourceType!: string;
    count!: number;

    [key: string]: any;

    constructor(data?: ISourceCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): SourceCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }
}

export interface ISourceCountDto {
    sourceType: string;
    count: number;

    [key: string]: any;
}

export class LegacyJsonRemainingDto implements ILegacyJsonRemainingDto {
    concertImages!: number;
    locationImages!: number;
    concertSeriesBanner!: number;
    concertSeriesPicture!: number;

    [key: string]: any;

    constructor(data?: ILegacyJsonRemainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.concertImages = _data["concertImages"] !== undefined ? _data["concertImages"] : null as any;
            this.locationImages = _data["locationImages"] !== undefined ? _data["locationImages"] : null as any;
            this.concertSeriesBanner = _data["concertSeriesBanner"] !== undefined ? _data["concertSeriesBanner"] : null as any;
            this.concertSeriesPicture = _data["concertSeriesPicture"] !== undefined ? _data["concertSeriesPicture"] : null as any;
        }
    }

    static fromJS(data: any): LegacyJsonRemainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyJsonRemainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["concertImages"] = this.concertImages !== undefined ? this.concertImages : null as any;
        data["locationImages"] = this.locationImages !== undefined ? this.locationImages : null as any;
        data["concertSeriesBanner"] = this.concertSeriesBanner !== undefined ? this.concertSeriesBanner : null as any;
        data["concertSeriesPicture"] = this.concertSeriesPicture !== undefined ? this.concertSeriesPicture : null as any;
        return data;
    }
}

export interface ILegacyJsonRemainingDto {
    concertImages: number;
    locationImages: number;
    concertSeriesBanner: number;
    concertSeriesPicture: number;

    [key: string]: any;
}

export class LinkMigrationReportDto implements ILinkMigrationReportDto {
    imageLinksTotal!: number;
    contentFileLinksTotal!: number;
    fileReferencesTotal!: number;
    imageLinksBySource!: SourceCountDto[];
    contentFileLinksBySource!: SourceCountDto[];
    fileReferencesBySource!: SourceCountDto[];
    legacyJsonRemaining!: LegacyJsonRemainingDto;

    [key: string]: any;

    constructor(data?: ILinkMigrationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageLinksBySource = [];
            this.contentFileLinksBySource = [];
            this.fileReferencesBySource = [];
            this.legacyJsonRemaining = new LegacyJsonRemainingDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.imageLinksTotal = _data["imageLinksTotal"] !== undefined ? _data["imageLinksTotal"] : null as any;
            this.contentFileLinksTotal = _data["contentFileLinksTotal"] !== undefined ? _data["contentFileLinksTotal"] : null as any;
            this.fileReferencesTotal = _data["fileReferencesTotal"] !== undefined ? _data["fileReferencesTotal"] : null as any;
            if (Array.isArray(_data["imageLinksBySource"])) {
                this.imageLinksBySource = [] as any;
                for (let item of _data["imageLinksBySource"])
                    this.imageLinksBySource!.push(SourceCountDto.fromJS(item));
            }
            else {
                this.imageLinksBySource = null as any;
            }
            if (Array.isArray(_data["contentFileLinksBySource"])) {
                this.contentFileLinksBySource = [] as any;
                for (let item of _data["contentFileLinksBySource"])
                    this.contentFileLinksBySource!.push(SourceCountDto.fromJS(item));
            }
            else {
                this.contentFileLinksBySource = null as any;
            }
            if (Array.isArray(_data["fileReferencesBySource"])) {
                this.fileReferencesBySource = [] as any;
                for (let item of _data["fileReferencesBySource"])
                    this.fileReferencesBySource!.push(SourceCountDto.fromJS(item));
            }
            else {
                this.fileReferencesBySource = null as any;
            }
            this.legacyJsonRemaining = _data["legacyJsonRemaining"] ? LegacyJsonRemainingDto.fromJS(_data["legacyJsonRemaining"]) : new LegacyJsonRemainingDto();
        }
    }

    static fromJS(data: any): LinkMigrationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMigrationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["imageLinksTotal"] = this.imageLinksTotal !== undefined ? this.imageLinksTotal : null as any;
        data["contentFileLinksTotal"] = this.contentFileLinksTotal !== undefined ? this.contentFileLinksTotal : null as any;
        data["fileReferencesTotal"] = this.fileReferencesTotal !== undefined ? this.fileReferencesTotal : null as any;
        if (Array.isArray(this.imageLinksBySource)) {
            data["imageLinksBySource"] = [];
            for (let item of this.imageLinksBySource)
                data["imageLinksBySource"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.contentFileLinksBySource)) {
            data["contentFileLinksBySource"] = [];
            for (let item of this.contentFileLinksBySource)
                data["contentFileLinksBySource"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.fileReferencesBySource)) {
            data["fileReferencesBySource"] = [];
            for (let item of this.fileReferencesBySource)
                data["fileReferencesBySource"].push(item ? item.toJSON() : null as any);
        }
        data["legacyJsonRemaining"] = this.legacyJsonRemaining ? this.legacyJsonRemaining.toJSON() : null as any;
        return data;
    }
}

export interface ILinkMigrationReportDto {
    imageLinksTotal: number;
    contentFileLinksTotal: number;
    fileReferencesTotal: number;
    imageLinksBySource: SourceCountDto[];
    contentFileLinksBySource: SourceCountDto[];
    fileReferencesBySource: SourceCountDto[];
    legacyJsonRemaining: LegacyJsonRemainingDto;

    [key: string]: any;
}

export class UpdateConcertPlanDto implements IUpdateConcertPlanDto {
    mode!: UpdateConcertPlanDtoMode;
    planId?: number | null;

    [key: string]: any;

    constructor(data?: IUpdateConcertPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.planId = _data["planId"] !== undefined ? _data["planId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateConcertPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConcertPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["planId"] = this.planId !== undefined ? this.planId : null as any;
        return data;
    }
}

export interface IUpdateConcertPlanDto {
    mode: UpdateConcertPlanDtoMode;
    planId?: number | null;

    [key: string]: any;
}

export class ReuseConcertPlanDto implements IReuseConcertPlanDto {
    name!: string;
    locationId?: number | null;

    [key: string]: any;

    constructor(data?: IReuseConcertPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
        }
    }

    static fromJS(data: any): ReuseConcertPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReuseConcertPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        return data;
    }
}

export interface IReuseConcertPlanDto {
    name: string;
    locationId?: number | null;

    [key: string]: any;
}

export class PlanAdminDto implements IPlanAdminDto {
    name!: string;
    locationId?: number | null;
    plan!: PlanDto;
    id!: number;
    dateCreated!: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;

    constructor(data?: IPlanAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plan = new PlanDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.plan = _data["plan"] ? PlanDto.fromJS(_data["plan"]) : new PlanDto();
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PlanAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["plan"] = this.plan ? this.plan.toJSON() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        return data;
    }
}

export interface IPlanAdminDto {
    name: string;
    locationId?: number | null;
    plan: PlanDto;
    id: number;
    dateCreated: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;
}

export class UpsertPlanDto implements IUpsertPlanDto {
    name!: string;
    locationId?: number | null;
    plan!: PlanDto;

    [key: string]: any;

    constructor(data?: IUpsertPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plan = new PlanDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.plan = _data["plan"] ? PlanDto.fromJS(_data["plan"]) : new PlanDto();
        }
    }

    static fromJS(data: any): UpsertPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["plan"] = this.plan ? this.plan.toJSON() : null as any;
        return data;
    }
}

export interface IUpsertPlanDto {
    name: string;
    locationId?: number | null;
    plan: PlanDto;

    [key: string]: any;
}

export class UpsertPlaylistItemDto implements IUpsertPlaylistItemDto {
    artist!: string;
    title!: string;

    [key: string]: any;

    constructor(data?: IUpsertPlaylistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.artist = _data["artist"] !== undefined ? _data["artist"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): UpsertPlaylistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPlaylistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["artist"] = this.artist !== undefined ? this.artist : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IUpsertPlaylistItemDto {
    artist: string;
    title: string;

    [key: string]: any;
}

export class PlaylistAdminDto implements IPlaylistAdminDto {
    year!: number;
    month?: number | null;
    image?: string | null;
    playlist!: UpsertPlaylistItemDto[];
    id!: number;
    dateCreated!: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;

    constructor(data?: IPlaylistAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.playlist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.month = _data["month"] !== undefined ? _data["month"] : null as any;
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            if (Array.isArray(_data["playlist"])) {
                this.playlist = [] as any;
                for (let item of _data["playlist"])
                    this.playlist!.push(UpsertPlaylistItemDto.fromJS(item));
            }
            else {
                this.playlist = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : null as any;
            this.dateChanged = _data["dateChanged"] ? DateTime.fromISO(_data["dateChanged"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PlaylistAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["month"] = this.month !== undefined ? this.month : null as any;
        data["image"] = this.image !== undefined ? this.image : null as any;
        if (Array.isArray(this.playlist)) {
            data["playlist"] = [];
            for (let item of this.playlist)
                data["playlist"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : null as any;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toString() : null as any;
        return data;
    }
}

export interface IPlaylistAdminDto {
    year: number;
    month?: number | null;
    image?: string | null;
    playlist: UpsertPlaylistItemDto[];
    id: number;
    dateCreated: DateTime;
    dateChanged?: DateTime | null;

    [key: string]: any;
}

export class UpsertPlaylistDto implements IUpsertPlaylistDto {
    year!: number;
    month?: number | null;
    image?: string | null;
    playlist!: UpsertPlaylistItemDto[];

    [key: string]: any;

    constructor(data?: IUpsertPlaylistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.playlist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.month = _data["month"] !== undefined ? _data["month"] : null as any;
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            if (Array.isArray(_data["playlist"])) {
                this.playlist = [] as any;
                for (let item of _data["playlist"])
                    this.playlist!.push(UpsertPlaylistItemDto.fromJS(item));
            }
            else {
                this.playlist = null as any;
            }
        }
    }

    static fromJS(data: any): UpsertPlaylistDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPlaylistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["month"] = this.month !== undefined ? this.month : null as any;
        data["image"] = this.image !== undefined ? this.image : null as any;
        if (Array.isArray(this.playlist)) {
            data["playlist"] = [];
            for (let item of this.playlist)
                data["playlist"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUpsertPlaylistDto {
    year: number;
    month?: number | null;
    image?: string | null;
    playlist: UpsertPlaylistItemDto[];

    [key: string]: any;
}

export class PlaylistImportResultDto implements IPlaylistImportResultDto {
    isSuccessful!: boolean;
    dryRun!: boolean;
    year!: number;
    month?: number;
    entries!: number;
    imageUrl?: string;
    playlistId?: number;

    [key: string]: any;

    constructor(data?: IPlaylistImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.isSuccessful = true;
            this.dryRun = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSuccessful = _data["isSuccessful"] !== undefined ? _data["isSuccessful"] : true;
            this.dryRun = _data["dryRun"] !== undefined ? _data["dryRun"] : false;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.month = _data["month"] !== undefined ? _data["month"] : null as any;
            this.entries = _data["entries"] !== undefined ? _data["entries"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.playlistId = _data["playlistId"] !== undefined ? _data["playlistId"] : null as any;
        }
    }

    static fromJS(data: any): PlaylistImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSuccessful"] = this.isSuccessful !== undefined ? this.isSuccessful : null as any;
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["month"] = this.month !== undefined ? this.month : null as any;
        data["entries"] = this.entries !== undefined ? this.entries : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["playlistId"] = this.playlistId !== undefined ? this.playlistId : null as any;
        return data;
    }
}

export interface IPlaylistImportResultDto {
    isSuccessful: boolean;
    dryRun: boolean;
    year: number;
    month?: number;
    entries: number;
    imageUrl?: string;
    playlistId?: number;

    [key: string]: any;
}

export class AlbumDataDto implements IAlbumDataDto {
    artist!: string;
    title!: string;

    [key: string]: any;

    constructor(data?: IAlbumDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.artist = _data["artist"] !== undefined ? _data["artist"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): AlbumDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["artist"] = this.artist !== undefined ? this.artist : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IAlbumDataDto {
    artist: string;
    title: string;

    [key: string]: any;
}

export class PlaylistDataDto implements IPlaylistDataDto {
    year!: number;
    month?: number;
    image?: string;
    playlist!: AlbumDataDto[];

    [key: string]: any;

    constructor(data?: IPlaylistDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.playlist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.month = _data["month"] !== undefined ? _data["month"] : null as any;
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            if (Array.isArray(_data["playlist"])) {
                this.playlist = [] as any;
                for (let item of _data["playlist"])
                    this.playlist!.push(AlbumDataDto.fromJS(item));
            }
            else {
                this.playlist = null as any;
            }
        }
    }

    static fromJS(data: any): PlaylistDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["month"] = this.month !== undefined ? this.month : null as any;
        data["image"] = this.image !== undefined ? this.image : null as any;
        if (Array.isArray(this.playlist)) {
            data["playlist"] = [];
            for (let item of this.playlist)
                data["playlist"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlaylistDataDto {
    year: number;
    month?: number;
    image?: string;
    playlist: AlbumDataDto[];

    [key: string]: any;
}

export enum OrderBy {
    DateCreated = "DateCreated",
    ConcertDate_Created = "ConcertDate.Created",
    Concert_Name = "Concert.Name",
    Name = "Name",
}

export enum OrderBy2 {
    DateCreated = "DateCreated",
    ConcertDate_Created = "ConcertDate.Created",
    Concert_Name = "Concert.Name",
    Name = "Name",
}

export enum SortBy {
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FileName = "fileName",
    OriginalName = "originalName",
    Size = "size",
    Title = "title",
    Category = "category",
}

export enum Order {
    Asc = "asc",
    Desc = "desc",
}

export enum SortBy2 {
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FileName = "fileName",
    OriginalName = "originalName",
    Size = "size",
    Title = "title",
    Category = "category",
}

export enum Order2 {
    Asc = "asc",
    Desc = "desc",
}

export enum MessageDtoType {
    ERROR = "ERROR",
    WARNING = "WARNING",
    INFO = "INFO",
    SUCCESS = "SUCCESS",
}

export enum ImageDtoType {
    Advertising = "Advertising",
    Banner = "Banner",
    ConcertPicture = "ConcertPicture",
}

export enum AreaDtoVerticalAlign {
    Top = "Top",
    Bottom = "Bottom",
    Middle = "Middle",
}

export enum AreaDtoHorizontalAlign {
    Left = "Left",
    Right = "Right",
    Center = "Center",
}

export enum RowSettingsDtoSeatCountDirection {
    LikeBlockDefinition = "LikeBlockDefinition",
    LeftToRight = "LeftToRight",
    RightToLeft = "RightToLeft",
}

export enum BlockDtoSeatCountDirection {
    LikeBlockDefinition = "LikeBlockDefinition",
    LeftToRight = "LeftToRight",
    RightToLeft = "RightToLeft",
}

export enum BlockDtoBlockLayoutType {
    Rows = "rows",
    Table = "table",
    Radial = "radial",
}

export enum BlockDtoTableShape {
    Round = "round",
    Rect = "rect",
}

export enum BlockRestrictionDtoSkipRowMode {
    None = "None",
    Even = "Even",
    UnEven = "UnEven",
}

export enum RestrictionDtoSkipRowMode {
    None = "None",
    Even = "Even",
    UnEven = "UnEven",
}

export enum CommentDtoLevel {
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
    Success = "Success",
}

export enum CommentDtoCommentType {
    Concert = "Concert",
    TicketSale = "TicketSale",
    InPast = "InPast",
    Canceled = "Canceled",
    NoDate = "NoDate",
    Postponed = "Postponed",
    Alert = "Alert",
}

export class Plan extends PlanDto implements IPlan {

    [key: string]: any;

    constructor(data?: IPlan) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static override fromJS(data: any): Plan {
        data = typeof data === 'object' ? data : {};
        let result = new Plan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPlan extends IPlanDto {

    [key: string]: any;
}

export enum ContentItemDtoType {
    Text = "Text",
    Audio = "Audio",
    Banner = "Banner",
    DefaultPicture = "DefaultPicture",
    TicketReservationLink = "TicketReservationLink",
    ConcertInfo = "ConcertInfo",
    Picture = "Picture",
    Gallery = "Gallery",
    Link = "Link",
    Space = "Space",
    Alert = "Alert",
    Quote = "Quote",
    Header1 = "Header1",
    Header2 = "Header2",
    Header3 = "Header3",
}

export enum ContentItemDtoAlertLevel {
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
    Success = "Success",
}

export class Banner extends ImageDto implements IBanner {

    [key: string]: any;

    constructor(data?: IBanner) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static override fromJS(data: any): Banner {
        data = typeof data === 'object' ? data : {};
        let result = new Banner();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBanner extends IImageDto {

    [key: string]: any;
}

export class Picture extends ImageDto implements IPicture {

    [key: string]: any;

    constructor(data?: IPicture) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static override fromJS(data: any): Picture {
        data = typeof data === 'object' ? data : {};
        let result = new Picture();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPicture extends IImageDto {

    [key: string]: any;
}

export class Plan2 extends PlanDto implements IPlan2 {

    [key: string]: any;

    constructor(data?: IPlan2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static override fromJS(data: any): Plan2 {
        data = typeof data === 'object' ? data : {};
        let result = new Plan2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPlan2 extends IPlanDto {

    [key: string]: any;
}

export class Banner2 extends ImageDto implements IBanner2 {

    [key: string]: any;

    constructor(data?: IBanner2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static override fromJS(data: any): Banner2 {
        data = typeof data === 'object' ? data : {};
        let result = new Banner2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBanner2 extends IImageDto {

    [key: string]: any;
}

export class Picture2 extends ImageDto implements IPicture2 {

    [key: string]: any;

    constructor(data?: IPicture2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static override fromJS(data: any): Picture2 {
        data = typeof data === 'object' ? data : {};
        let result = new Picture2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPicture2 extends IImageDto {

    [key: string]: any;
}

export enum UpdateConcertPlanDtoMode {
    Link = "link",
    Use = "use",
    Unlink = "unlink",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}